// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:00:29.996Z
// Property: 152 Northland (ID: 6767906449166542)
// Collections: 30 amenities, 9 floorplans (live), 62 photos, 64 POIs, 1 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449166542",
  "property_external_id": "2162171",
  "property_zillow_url": "https://www.zillow.com/apartments/kansas-city-mo/152-northland/CqcTrV/",
  "property_apartments_url": "https://www.apartments.com/152-northland-kansas-city-mo/jhkplr4/",
  "property_google_business_url": "https://www.google.com/maps/place/152+Northland+Apartments/data=!4m2!3m1!1s0x0:0x3c1d2bcffe4153c5?sa=X&ved=2ahUKEwjL1dO-g72SAxVmNlkFHTptGcIQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "152-northland",
  "property_name": "152 Northland",
  "property_website_url": "https://www.caseusa.com/apartments/mo/kansas-city/152-northland/",
  "property_domain": null,
  "property_address": "8800 North Ames Avenue",
  "property_full_address": "8800 N. Ames Drive, Kansas City, MO, 64154",
  "property_address_1": "8800 N. Ames Drive",
  "property_address_2": null,
  "property_address_city": "Kansas City",
  "property_address_state": "MO",
  "property_address_zip_full": null,
  "property_address_zip": "64154",
  "property_address_country": "US",
  "property_address_county": "Platte County",
  "property_neighborhood_address": "Outer Northland-Platte County",
  "property_address_latitude": "39.253",
  "property_address_longitude": "-94.6014",
  "property_email": "152northland@caseusa.com",
  "property_phone": "(816) 475-5649",
  "property_call_tracking_phone": "833-725-9625",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At 152 Northland in Kansas City, MO, contemporary living meets comfort. Choose from unique one and two-bedroom floor plans that feature spacious layouts, modern appliances, and private balconies. Enjoy top-notch amenities, including a sundeck, fitness center, and clubhouse. Your perfect oasis awaits—browse availability or schedule your tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Welcome to 152 Northland – Your Ideal Home in Kansas City, MO!**\n\nDiscover your perfect sanctuary at 152 Northland, where comfort meets convenience. Our thoughtfully designed apartment community offers a range of stunning floor plans, featuring one and two-bedroom options tailored to suit your lifestyle. Each home boasts unique layouts with flex spaces, ideal for modern living.\n\nExperience unparalleled amenities crafted to elevate your living experience. Enjoy 24-hour access to a fully-equipped fitness center, a refreshing pool, and a vibrant clubhouse perfect for social gatherings. Our gated community ensures your peace of mind, while the on-site property manager and maintenance team are always here for you.\n\nStep outside and unwind in our beautifully landscaped courtyard or grill in our Grill & Chill area. Basketball enthusiasts will love the dedicated court, while those seeking relaxation can indulge on the sundeck or their private patio or balcony. Inside your apartment, you’ll find luxurious touches like vaulted ceilings*, custom cabinetry, and modern stainless-steel appliances, alongside convenient features such as washer/dryer hookups, generous closet space, and electronic thermostats.\n\nAt 152 Northland, we care for the environment too! Benefit from on-site recycling and curbside trash pickup. Plus, with flexible payment options available, moving in has never been easier.\n\nWhether you’re looking to relax or stay active, our community has it all. Find your new home today – browse our availability or schedule a tour to visit 152 Northland and experience Kansas City living at its finest!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
    "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
    "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "341",
  "property_year_built": "2026",
  "property_year_renovated": null,
  "property_walk_score": "21",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.13489736070382",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "225-325",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed Restrictions Apply",
  "property_pet_policy_description": "Pets up to 80 LBS",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://152northlandapartmentskc.securecafe.com/onlineleasing/152-northland/floorplans.aspx",
  "property_resident_portal_url": "https://152northlandapartmentskc.securecafenet.com/residentservices/152-northland/userlogin",
  "property_apply_now_url": "https://152northlandapartmentskc.securecafe.com/onlineleasing/152-northland/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4e-6a9e-714d-868b-85648f0ded3f.webp",
  "property_primary_logo_media": {
    "alt_text": "Logo for 152 Northland",
    "public_id": "019cfb4e-6a9e-714d-868b-85648f0ded3f",
    "storage_key": "property/6767906449166542/019cfb4e-6a9e-714d-868b-85648f0ded3f.webp",
    "width": 350,
    "height": 215
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4e-74f6-771e-ab6d-03e77acc25ac.webp",
  "property_mono_white_logo_media": {
    "alt_text": "152 Northland logo",
    "public_id": "019cfb4e-74f6-771e-ab6d-03e77acc25ac",
    "storage_key": "property/6767906449166542/019cfb4e-74f6-771e-ab6d-03e77acc25ac.webp",
    "width": 350,
    "height": 215
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4e-7cc1-7031-865f-ecf470ec42f4.webp",
  "property_mono_black_logo_media": {
    "alt_text": "152 Northland logo",
    "public_id": "019cfb4e-7cc1-7031-865f-ecf470ec42f4",
    "storage_key": "property/6767906449166542/019cfb4e-7cc1-7031-865f-ecf470ec42f4.webp",
    "width": 350,
    "height": 215
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#e5107b",
  "property_secondary_color": "#504942",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1108",
  "property_sqft_min": "789",
  "property_sqft_max": "1108",
  "property_price_range": "1419 - 1779",
  "property_price_min": "1419",
  "property_price_max": "1779",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/152NorthlandAptsKC",
  "property_instagram_url": "https://www.instagram.com/152northlandaptskc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/152+Northland+Apartments/data=!4m2!3m1!1s0x0:0x3c1d2bcffe4153c5?sa=X&ved=2ahUKEwjL1dO-g72SAxVmNlkFHTptGcIQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=First+Watch&find_loc=NW+Barry+Rd%2C+Kansas+City%2C+MO",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 152 Northland",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection at Our Community",
  "property_home_amenities_blurb": "Nestled in the heart of Kansas City, 152 Northland boasts unique one and two-bedroom floor plans designed for modern living. Enjoy resort-style amenities like a refreshing pool, fitness center, and inviting clubhouse, perfect for relaxation and connection. Elevate your lifestyle—your perfect apartment awaits at 152 Northland!",
  "property_home_floorplans_blurb": "Welcome to 152 Northland in the heart of Kansas City, MO, where modern living meets comfort. Choose from thoughtfully designed one and two-bedroom apartments that fit your lifestyle. Browse our available homes and discover your perfect floor plan today—your ideal urban retreat awaits!",
  "property_home_gallery_blurb": "At 152 Northland in Kansas City, MO, your lifestyle awaits with spacious one and two-bedroom apartments. Enjoy a vibrant community featuring a sparkling pool, fitness center, and inviting clubhouse. Embrace comfort with modern amenities, unique floor plans, and relaxing outdoor spaces. Picture yourself living here and make it a reality today!",
  "property_home_neighborhood_blurb": "At 152 Northland, Kansas City's vibrant lifestyle awaits you. Our thoughtfully designed one and two-bedroom floor plans offer the perfect retreat. Experience the energy of local hotspots like Zona Rosa, PowerPlay Metro North, and the serene English Landing Park, all just moments from your door. Explore the possibilities today!",
  "property_home_reviews_blurb": "At 152 Northland in Kansas City, MO, residents rave about their vibrant community, saying it offers “an unbeatable atmosphere for both relaxation and fun.” Join a neighborhood that values connection and comfort. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At 152 Northland in Kansas City, MO, you'll find more than just a home; you'll discover a vibrant community surrounded by top-notch amenities. Enjoy close proximity to parks, schools, and entertainment venues, including PowerPlay Metro North and Lighthouse ArtSpace. Unleash your lifestyle—explore all the local favorites right at your doorstep!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At 152 Northland in Kansas City, MO, comfort meets convenience. Choose from unique one- and two-bedroom floor plans, each equipped with modern amenities like vaulted ceilings, quartz countertops, and generous closet space. Enjoy our 24-hour fitness center, inviting clubhouse, and tranquil courtyard, all designed to elevate your living experience.",
  "property_applynow_blurb": "At 152 Northland in Kansas City, MO, unique floor plans await with one and two-bedroom options tailored to your lifestyle. Enjoy luxury amenities like a refreshing pool, a state-of-the-art fitness center, and a vibrant clubhouse. Embrace comfort with vaulted ceilings and modern appliances—your new home is just a click away!",
  "property_contactus_blurb": "At 152 Northland in Kansas City, MO, choose from our thoughtfully designed one and two-bedroom floor plans, tailored for style and comfort. Whether you’re seeking a cozy retreat or a spacious haven, we have the perfect fit for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At 152 Northland in Kansas City, MO, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Curious about amenities or community highlights? Our FAQs page offers valuable insights to help you make the most of your future home. Dive in and get your questions answered today!",
  "property_floorplans_blurb": "At 152 Northland in Kansas City, MO, stylish living awaits! Choose from thoughtfully designed one and two-bedroom floor plans that suit your lifestyle. Each space offers modern comforts and unique charm. Browse our available apartment homes today and find the ideal floor plan to call your own!",
  "property_gallery_blurb": "At 152 Northland in Kansas City, MO, our vibrant community blends modern living with comfort. With unique one and two bedroom floor plans, enjoy plush carpets, custom cabinetry, and stunning pool views. Imagine relaxing on your private patio or grilling in our courtyard—snap a photo and picture yourself living here!",
  "property_interactivemap_blurb": "Welcome to 152 Northland, where modern comfort meets vibrant living in Kansas City, MO. Choose from thoughtfully designed one and two-bedroom floor plans, featuring sleek quartz countertops and spacious layouts. With 24-hour access, a fitness center, and a refreshing pool, your perfect oasis awaits. Check our interactive community map to find your ideal home today!",
  "property_pets_blurb": "At 152 Northland in Kansas City, MO, your perfect sanctuary awaits! With spacious living areas and modern amenities, our community embraces both comfort and style. Plus, your furry friends will thrive here—pets up to 80 lbs are happily accommodated. Embrace a vibrant lifestyle in a place you can truly call home!",
  "property_referafriend_blurb": "At 152 Northland in vibrant Kansas City, MO, spacious floor plans await, from cozy one-bedroom retreats to expansive two-bedroom homes. Share the joy of exceptional living—great friends make great neighbors! Refer a friend today and let them discover the welcoming community that makes 152 Northland feel like home.",
  "property_residentaccess_blurb": "At 152 Northland in vibrant Kansas City, MO, choose from our thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Unlock the convenience of your resident portal—pay rent, schedule maintenance, and more—effortlessly at your fingertips. Welcome to modern living redefined!",
  "property_reviews_blurb": "At 152 Northland in Kansas City, MO, residents rave about the vibrant community atmosphere that feels like home. One resident shares, “The sense of community here is unmatched!” Join us and see what our residents have to say about living at our welcoming apartment community!",
  "property_created_at": "1759850681753",
  "property_scheduletour_blurb": "At 152 Northland in Kansas City, MO, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Ready to experience the vibrant lifestyle our residents love? Schedule a tour today and hear firsthand why they thrive in our welcoming community!",
  "property_thankyou_blurb": "Thank you for reaching out! At 152 Northland, Kansas City, MO, our diverse floor plans—spacious one and two-bedroom options—are designed to suit your lifestyle. Stay tuned; a team member will be in touch soon to help you find your perfect new home! Your community awaits.",
  "property_virtualtours_blurb": "At 152 Northland in vibrant Kansas City, MO, our thoughtfully designed one- and two-bedroom apartments await your personal touch. Experience modern living with spacious layouts and stunning community amenities. Dive into your future home with a virtual tour—your new lifestyle is just a click away!",
  "property_copyright": "2026 All Rights Reserved. 152 Northland",
  "property_seo_title_home": "152 Northland |  Apartments in Kansas City, MO",
  "property_seo_description_home": "Elevate your lifestyle at 152 Northland, Kansas City! Enjoy unique floor plans, modern amenities, a sparkling pool, and a vibrant clubhouse!",
  "property_seo_title_floorplans": "Floor Plans | Kansas City, MO Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal floor plan at 152 Northland in Kansas City! Choose from stylish one and two-bedroom apartments that suit your lifestyle perfectly.",
  "property_seo_title_amenities": "Amenities | Kansas City, MO Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at 152 Northland in Kansas City, MO! Enjoy unique floor plans, modern amenities, and a vibrant community vibe. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Kansas City, MO",
  "property_seo_description_gallery": "Elevate your lifestyle at 152 Northland in Kansas City. From modern floor plans to exceptional amenities, picture your perfect home today!",
  "property_seo_title_virtualtours": "Virtual Tours | 152 Northland Apartments",
  "property_seo_description_virtualtours": "Experience Kansas City living at 152 Northland! Immerse yourself in our stylish one and two-bedroom apartments. Ready for a virtual tour? Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | 152 Northland Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at 152 Northland, Kansas City! Explore unique floor plans, top amenities, and a vibrant community—view our map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Kansas City, MO",
  "property_seo_description_neighborhood": "Experience vibrant Kansas City living at 152 Northland. Uncover local favorites and must-see spots just steps from your new home. What's nearby awaits!",
  "property_seo_title_contact": "Contact Us | 152 Northland",
  "property_seo_description_contact": "Connect with 152 Northland in Kansas City, MO! Explore our one- and two-bedroom floor plans. Have questions? Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Kansas City, MO",
  "property_seo_description_faqs": "Unlock the secrets of 152 Northland in Kansas City! Our FAQs page has the answers to elevate your living experience—luxury amenities await you!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kansas City, MO",
  "property_seo_description_reviews": "Join the 152 Northland family in Kansas City! See what our residents love about unique floor plans, top-notch amenities, and a vibrant community vibe.",
  "property_seo_title_applynow": "Apply Now | Apartments in Kansas City, MO",
  "property_seo_description_applynow": "Unwind at 152 Northland in Kansas City! Enjoy unique floor plans, modern amenities, and a vibrant community. Your perfect home awaits—apply online today!",
  "property_seo_title_residentaccess": "Resident Access | 152 Northland",
  "property_seo_description_residentaccess": "Log in to 152 Northland’s resident portal for easy rent payments, hassle-free maintenance requests, and seamless community updates—all at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | 152 Northland",
  "property_seo_description_referafriend": "Share the joy of 152 Northland! Refer a friend to your vibrant Kansas City home and enjoy preferred perks—because great friends make the best neighbors!",
  "property_seo_title_scheduletour": "Schedule a Tour | 152 Northland",
  "property_seo_description_scheduletour": "Experience life at 152 Northland in Kansas City, MO. Schedule your tour today and find your perfect apartment in a vibrant community tailored for you!",
  "property_seo_title_privacy": "Privacy Policy | 152 Northland",
  "property_seo_description_privacy": "Your privacy matters at 152 Northland in Kansas City, MO. Learn how we protect your personal information and ensure your peace of mind. Read our policy now!",
  "property_seo_title_accessibility": "Website Accessibility | 152 Northland",
  "property_seo_description_accessibility": "Embrace a seamless living experience at 152 Northland in Kansas City, MO. Our commitment to digital inclusion ensures everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | 152 Northland",
  "property_seo_description_sitemap": "Navigate 152 Northland's vibrant Kansas City community! Find your perfect apartment and explore our diverse amenities by checking out our sitemap today.",
  "property_seo_title_thankyou": "Thank You | 152 Northland",
  "property_seo_description_thankyou": "Thank you for your interest in 152 Northland! Expect to hear from our team soon as we help you find your perfect Kansas City home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Kansas City, MO",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787864311455",
  "amenities": [
    {
      "id": "ec_1b318c6920aee4cb7a8db8e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127396119",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75f4dec94e8f82e050d4c90e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127396120",
      "title": "Night Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f83e3bbdb24ab3aa0c5d205",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127396121",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0db71d7bd87ab76b8b1bba9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127396122",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_32a8440855e9e798f8991b0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127396123",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a17bf9a2a24c82514defa55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127396127",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3318a05449c0edfdf6e775f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127396128",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59af6ed32cf1c7f6750ddf3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127396129",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd0d791c7c743374a681432d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127396130",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38f61a6d38a908241076322f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127396131",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5750c67f53be10388bcfb483",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127396132",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7d4b1b5c09bb008036e5d8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127396133",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57164977ca9c1d44ca2cbeab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127396134",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_573b310280124df5370ef701",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "128017323",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d97b5bf92ea896f54503d00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397629",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44a50bf5ed64c3004d2cb2a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397630",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb9d47c8e1dfbab379a373a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397631",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7167d839ee929309a718a4a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397632",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c67329df268434b41fc0e324",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397633",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9f1315e84f47e97aca9fda78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397634",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_61cac89a7d4284a7c7f98f36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397635",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d1cdf3588cad4089c188535",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397636",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d22742586a0003ec1c64ceea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397637",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3ffdfcaa4a92a2bfffba3e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397638",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70088021debb3ccda0d8aca8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397639",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f94632ff4a4e570bfc5403a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397640",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_170cc8d21f2da9fce7485a1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397641",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54f1cf343c52b61c06b75a83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397642",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6d64ea4c0a1c1ca1565b462",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397643",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c17a4136cd2688e62d9b5df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "yardi",
      "external_id": "127397644",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_7ab18ae8-fb09-4a4b-ac5f-1cba78005bd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cef-0d8f-7676-b0bb-810a2b1d6fcb.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with a white sink, chrome faucet, and decorative wall hangings.",
        "public_id": "019f3cef-0d8f-7676-b0bb-810a2b1d6fcb",
        "storage_key": "property/6767906449166542/019f3cef-0d8f-7676-b0bb-810a2b1d6fcb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Chic bathroom featuring a spacious vanity with a sleek white sink and stylish decor, including woven baskets and wall art. A large mirror reflects the room, offering a glimpse of the adjacent bedroom.",
      "link": "",
      "alt_text": "Modern bathroom vanity with a white sink, chrome faucet, and decorative wall hangings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_31303527-d523-430a-a5b0-80f3c44e3416",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cef-092b-70fc-9f38-dcf60e752b7b.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelves and two wicker baskets.",
        "public_id": "019f3cef-092b-70fc-9f38-dcf60e752b7b",
        "storage_key": "property/6767906449166542/019f3cef-092b-70fc-9f38-dcf60e752b7b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and convenient storage baskets, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with shelves and two wicker baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ca34ce5b-aae9-43de-93bf-975d81409bd0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cef-0824-73ee-ac7f-609375abff05.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, large mirror, and bathtub with shower curtain.",
        "public_id": "019f3cef-0824-73ee-ac7f-609375abff05",
        "storage_key": "property/6767906449166542/019f3cef-0824-73ee-ac7f-609375abff05.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the modern comforts of this spacious bathroom, featuring a double vanity, ample storage, and a bathtub with a stylish shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, large mirror, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_52fbebd8-080c-4aa1-895f-17674fe3ef20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cef-077c-708e-99b1-59596279041b.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with white countertop, sink, and cabinets. Includes toilet, shower, and white towel.",
        "public_id": "019f3cef-077c-708e-99b1-59596279041b",
        "storage_key": "property/6767906449166542/019f3cef-077c-708e-99b1-59596279041b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a double vanity, modern fixtures, and a bathtub with a decorative shower curtain. A touch of greenery adds freshness.",
      "link": "",
      "alt_text": "Modern bathroom vanity with white countertop, sink, and cabinets. Includes toilet, shower, and white towel.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d4536c4d-9ba9-4515-acc4-7d4122f8ca7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-f933-7424-bad4-8d9993325e92.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, dresser, and nightstands.",
        "public_id": "019f3cee-f933-7424-bad4-8d9993325e92",
        "storage_key": "property/6767906449166542/019f3cee-f933-7424-bad4-8d9993325e92.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our spacious bedroom, featuring a plush queen-size bed, elegant dresser, and convenient nightstands. Perfect for relaxation.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed, dresser, and nightstands.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4a419a3f-d595-4e8a-bc8c-45bb58992bdb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-ddfb-7483-9a75-14ed3da5f51b.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment with a sofa, coffee table, TV, and kitchen island.",
        "public_id": "019f3cee-ddfb-7483-9a75-14ed3da5f51b",
        "storage_key": "property/6767906449166542/019f3cee-ddfb-7483-9a75-14ed3da5f51b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern living room seamlessly flows into a well-equipped kitchen, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Living room and kitchen area in an apartment with a sofa, coffee table, TV, and kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7b9caafd-90fe-4fd6-af12-c762e6894584",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-f0b6-72f2-9de0-c1e2642cd22f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, quartz countertops, stainless steel appliances, and an open view to the living room.",
        "public_id": "019f3cee-f0b6-72f2-9de0-c1e2642cd22f",
        "storage_key": "property/6767906449166542/019f3cee-f0b6-72f2-9de0-c1e2642cd22f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this bright and airy kitchen, featuring sleek white cabinetry, durable quartz countertops, and a suite of stainless steel appliances. The open-concept design seamlessly connects to the living area, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, quartz countertops, stainless steel appliances, and an open view to the living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bfc6b5a4-ff0e-4b44-ac7b-bd41bb08821d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-dd89-7279-8066-eaedb58008b1.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs, overlooking apartment buildings.",
        "public_id": "019f3cee-dd89-7279-8066-eaedb58008b1",
        "storage_key": "property/6767906449166542/019f3cee-dd89-7279-8066-eaedb58008b1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your meals in this bright dining area, featuring a round table and comfortable chairs, with a view of the surrounding apartment complex.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs, overlooking apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_32ac2bef-f473-4763-a538-4bff4aa157ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-d919-778a-ab8d-f9211e91b2d9.webp",
      "image_media": {
        "alt_text": "Home office with a desk and computer, adjacent to a dining area with a round table and chairs.",
        "public_id": "019f3cee-d919-778a-ab8d-f9211e91b2d9",
        "storage_key": "property/6767906449166542/019f3cee-d919-778a-ab8d-f9211e91b2d9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover a comfortable and functional living space with a dedicated home office area, perfect for remote work, and a stylish dining area for entertaining guests.",
      "link": "",
      "alt_text": "Home office with a desk and computer, adjacent to a dining area with a round table and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f070b3a-5a5f-44db-b73f-ed7f942d4e9d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-dfe3-77cc-ac1d-3be25d913971.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and subway tile backsplash.",
        "public_id": "019f3cee-dfe3-77cc-ac1d-3be25d913971",
        "storage_key": "property/6767906449166542/019f3cee-dfe3-77cc-ac1d-3be25d913971.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek white cabinetry, durable quartz countertops, and a classic subway tile backsplash. Perfect for culinary adventures.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0824b3e1-467e-465c-9c11-32ad855712e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-cf6c-734e-b35f-3e0f1d79b049.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and desk with computer.",
        "public_id": "019f3cee-cf6c-734e-b35f-3e0f1d79b049",
        "storage_key": "property/6767906449166542/019f3cee-cf6c-734e-b35f-3e0f1d79b049.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, stylish armchair, and a functional desk area. Perfect for relaxing or working from home.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, coffee table, and desk with computer.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5016774f-d79a-4e4b-8c7f-0cdcc3039263",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-ca66-739b-9273-96fa1cf744c8.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with neutral tones and modern furnishings.",
        "public_id": "019f3cee-ca66-739b-9273-96fa1cf744c8",
        "storage_key": "property/6767906449166542/019f3cee-ca66-739b-9273-96fa1cf744c8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this open-concept apartment, featuring a stylish kitchen and a versatile living space perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Spacious living room and kitchen area with neutral tones and modern furnishings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1384d0e7-2e8e-427b-a729-24c35762d5de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-c987-7195-a368-684feb1db138.webp",
      "image_media": {
        "alt_text": "Balcony view of apartment complex with outdoor seating and courtyard",
        "public_id": "019f3cee-c987-7195-a368-684feb1db138",
        "storage_key": "property/6767906449166542/019f3cee-c987-7195-a368-684feb1db138.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony overlooking the community courtyard and pool area.",
      "link": "",
      "alt_text": "Balcony view of apartment complex with outdoor seating and courtyard",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_15a3bf0b-21a0-4dae-a0a8-18224997c32a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-bcbd-70e0-9567-b204949b4045.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with a white sink, chrome faucet, and wooden cabinetry. Features artwork of a lighthouse and decorative wall hangings.",
        "public_id": "019f3cee-bcbd-70e0-9567-b204949b4045",
        "storage_key": "property/6767906449166542/019f3cee-bcbd-70e0-9567-b204949b4045.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A stylish and functional bathroom vanity featuring a spacious countertop, ample storage, and contemporary fixtures. Includes nautical-themed artwork and chic wall decor for a refined aesthetic.",
      "link": "",
      "alt_text": "Modern bathroom vanity with a white sink, chrome faucet, and wooden cabinetry. Features artwork of a lighthouse and decorative wall hangings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_84758bb0-2940-44be-aebc-6e112e0d1cf6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-bebb-752b-934c-c785a4e5032f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, dark wood cabinets, and a shower with a striped curtain.",
        "public_id": "019f3cee-bebb-752b-934c-c785a4e5032f",
        "storage_key": "property/6767906449166542/019f3cee-bebb-752b-934c-c785a4e5032f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This modern bathroom features a sleek white vanity with ample storage, complemented by dark wood cabinets. The shower area has a clean, contemporary look with a striped curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, dark wood cabinets, and a shower with a striped curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a6521aec-1cbf-4599-81a8-50bdab34841b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-a93b-727b-aeb1-b55ead8de997.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, dresser, and large mirror.",
        "public_id": "019f3cee-a93b-727b-aeb1-b55ead8de997",
        "storage_key": "property/6767906449166542/019f3cee-a93b-727b-aeb1-b55ead8de997.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, a spacious dresser, and a large mirror for your convenience.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, dresser, and large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a5c6250d-1bbd-4806-b036-cb2892bb956a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-a556-70ca-b2e9-2c5deb916228.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, dark wood cabinets, and toilet.",
        "public_id": "019f3cee-a556-70ca-b2e9-2c5deb916228",
        "storage_key": "property/6767906449166542/019f3cee-a556-70ca-b2e9-2c5deb916228.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with white countertops, ample dark wood cabinetry, and a separate toilet area.",
      "link": "",
      "alt_text": "Bathroom with double vanity, dark wood cabinets, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7bba1d97-d1d2-4311-b7c7-fd0c3bd4882e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-9ed5-7179-aba4-f8bf1723d947.webp",
      "image_media": {
        "alt_text": "A modern bedroom with a queen-size bed, wooden furniture, and a ceiling fan.",
        "public_id": "019f3cee-9ed5-7179-aba4-f8bf1723d947",
        "storage_key": "property/6767906449166542/019f3cee-9ed5-7179-aba4-f8bf1723d947.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our spacious bedrooms, featuring contemporary design and ample natural light.",
      "link": "",
      "alt_text": "A modern bedroom with a queen-size bed, wooden furniture, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_049c6c36-be8e-4010-83b6-4821ca2228d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-72f4-76c4-8409-b4011803ad30.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with attached garages.",
        "public_id": "019f3cee-72f4-76c4-8409-b4011803ad30",
        "storage_key": "property/6767906449166542/019f3cee-72f4-76c4-8409-b4011803ad30.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Showcasing the modern exterior and attached garages of this apartment building.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with attached garages.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cc50f100-10d8-4f7c-98a9-555cf996eed2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-76b7-7752-a603-d3395791cb2e.webp",
      "image_media": {
        "alt_text": "Serene bedroom with a king-size bed, blue bedding, and a large abstract artwork.",
        "public_id": "019f3cee-76b7-7752-a603-d3395791cb2e",
        "storage_key": "property/6767906449166542/019f3cee-76b7-7752-a603-d3395791cb2e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this beautifully appointed bedroom, featuring plush bedding, elegant decor, and ample natural light.",
      "link": "",
      "alt_text": "Serene bedroom with a king-size bed, blue bedding, and a large abstract artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f903e35b-00c3-4240-b481-e696a3820947",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-7286-72d9-8fcb-52b74c66f62f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and dark wood cabinets.",
        "public_id": "019f3cee-7286-72d9-8fcb-52b74c66f62f",
        "storage_key": "property/6767906449166542/019f3cee-7286-72d9-8fcb-52b74c66f62f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and dark wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_46b0fbc4-286f-40b6-8a02-c8b9cd42ce9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-7472-729c-ab4b-cfad14f3f1b4.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, TV, and view of a bedroom.",
        "public_id": "019f3cee-7472-729c-ab4b-cfad14f3f1b4",
        "storage_key": "property/6767906449166542/019f3cee-7472-729c-ab4b-cfad14f3f1b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, stylish armchairs, and a large TV, with an adjoining bedroom visible.",
      "link": "",
      "alt_text": "Living room with sofa, armchair, coffee table, TV, and view of a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fb3b6ab6-cf54-4118-9769-ff5fd51cd9ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-7486-77af-9873-4ac2b68b9a06.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, large mirror, and shower/tub combo with blue striped curtain.",
        "public_id": "019f3cee-7486-77af-9873-4ac2b68b9a06",
        "storage_key": "property/6767906449166542/019f3cee-7486-77af-9873-4ac2b68b9a06.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort with this beautifully appointed apartment bathroom, featuring a sleek white vanity, ample mirror space, and a pristine shower/tub combination.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, large mirror, and shower/tub combo with blue striped curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a339ec39-e3e1-4931-91ac-cd37014277ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-748c-73c3-b369-d8ad38c267df.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with covered parking and garages.",
        "public_id": "019f3cee-748c-73c3-b369-d8ad38c267df",
        "storage_key": "property/6767906449166542/019f3cee-748c-73c3-b369-d8ad38c267df.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring covered parking, garages, and classic architectural details.",
      "link": "",
      "alt_text": "Exterior of apartment building with covered parking and garages.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_00d6139e-11b1-4a3b-a06b-6ad3fb7acd89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cee-7467-75cc-993b-10757dbe3d0e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white subway tile backsplash.",
        "public_id": "019f3cee-7467-75cc-993b-10757dbe3d0e",
        "storage_key": "property/6767906449166542/019f3cee-7467-75cc-993b-10757dbe3d0e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring dark wood cabinetry, sleek stainless steel appliances including a microwave and oven, and a classic white subway tile backsplash. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f85f535d-d315-47cc-bc11-1041ffd62de2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-a686-769f-8bdb-a572ad297187.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with stainless steel refrigerator, white cabinets, and granite countertops.",
        "public_id": "019f3ced-a686-769f-8bdb-a572ad297187",
        "storage_key": "property/6767906449166542/019f3ced-a686-769f-8bdb-a572ad297187.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience sophisticated living in this modern apartment kitchen, featuring sleek stainless steel appliances, ample cabinet space, and elegant granite countertops.",
      "link": "",
      "alt_text": "Modern apartment kitchen with stainless steel refrigerator, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_79b13ddf-84d1-41fa-bde8-4313aca75f42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-a992-756e-b328-df1435574a46.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019f3ced-a992-756e-b328-df1435574a46",
        "storage_key": "property/6767906449166542/019f3ced-a992-756e-b328-df1435574a46.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring sleek white cabinetry, a stainless steel range and microwave, and ample counter space.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c1e50b98-fc42-4865-b78f-b5a837346e80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-da91-75ae-8dda-d1f47208078d.webp",
      "image_media": {
        "alt_text": "Stylish living room with a curved sofa, armchairs, and a coffee table.",
        "public_id": "019f3ced-da91-75ae-8dda-d1f47208078d",
        "storage_key": "property/6767906449166542/019f3ced-da91-75ae-8dda-d1f47208078d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Unwind in this elegantly furnished living space, featuring a plush sofa and comfortable armchairs perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Stylish living room with a curved sofa, armchairs, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6ab95723-14f0-49cf-9f4e-a45994b75053",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-e83a-77dc-91c8-f69832383412.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, chrome faucet, and a large mirror with butterfly artwork.",
        "public_id": "019f3ced-e83a-77dc-91c8-f69832383412",
        "storage_key": "property/6767906449166542/019f3ced-e83a-77dc-91c8-f69832383412.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and clean bathroom featuring a contemporary vanity, a full-sized bathtub with a shower curtain, and elegant tile work.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, chrome faucet, and a large mirror with butterfly artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0f353cac-c3c6-4ae4-9244-82c5fef47825",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-e63c-71af-ab2e-2ac2472bf0a9.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with a white countertop, sink, and chrome faucet. Decorated with plants and wall art.",
        "public_id": "019f3ced-e63c-71af-ab2e-2ac2472bf0a9",
        "storage_key": "property/6767906449166542/019f3ced-e63c-71af-ab2e-2ac2472bf0a9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the modern comforts of this beautifully appointed bathroom, featuring a spacious vanity, ample counter space, and elegant decor.",
      "link": "",
      "alt_text": "Modern bathroom vanity with a white countertop, sink, and chrome faucet. Decorated with plants and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bb9243bd-8aa9-40eb-abc5-e503da8d3526",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-d734-723a-841f-5b4dbb9b9516.webp",
      "image_media": {
        "alt_text": "Cozy dining nook with a small marble table and two plush chairs, next to a balcony door.",
        "public_id": "019f3ced-d734-723a-841f-5b4dbb9b9516",
        "storage_key": "property/6767906449166542/019f3ced-d734-723a-841f-5b4dbb9b9516.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy intimate meals or morning coffee in this charming dining nook, featuring a stylish marble table and comfortable seating, with access to your private balcony.",
      "link": "",
      "alt_text": "Cozy dining nook with a small marble table and two plush chairs, next to a balcony door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_87fa388f-1c2d-4a63-911a-b8859e53df11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-a870-72ad-bdce-4a4f6dc90e8a.webp",
      "image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and fireplace.",
        "public_id": "019f3ced-a870-72ad-bdce-4a4f6dc90e8a",
        "storage_key": "property/6767906449166542/019f3ced-a870-72ad-bdce-4a4f6dc90e8a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this inviting living room, complete with a comfortable leather sofa, plush armchair, and a modern electric fireplace. Perfect for cozy evenings.",
      "link": "",
      "alt_text": "Living room with a leather sofa, armchair, coffee table, and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8eb2d986-fd27-4e79-8567-cb749417c564",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-a3df-775f-a862-c2326b642d01.webp",
      "image_media": {
        "alt_text": "Open concept living and kitchen area with leather sofa, accent chair, dining table, and kitchen island.",
        "public_id": "019f3ced-a3df-775f-a862-c2326b642d01",
        "storage_key": "property/6767906449166542/019f3ced-a3df-775f-a862-c2326b642d01.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy spacious living in this open-concept apartment, featuring a modern kitchen with an island, a comfortable living area, and a dedicated dining space. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Open concept living and kitchen area with leather sofa, accent chair, dining table, and kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c727b72c-22a0-4d49-b480-71da51b53ae2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-a3dd-72c9-8d1a-dd2ca0c66528.webp",
      "image_media": {
        "alt_text": "Living room with a curved sofa, accent chair, round coffee table, and decorative artwork.",
        "public_id": "019f3ced-a3dd-72c9-8d1a-dd2ca0c66528",
        "storage_key": "property/6767906449166542/019f3ced-a3dd-72c9-8d1a-dd2ca0c66528.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish living room, featuring a comfortable curved sofa and chic seating, perfect for entertaining or enjoying a quiet evening.",
      "link": "",
      "alt_text": "Living room with a curved sofa, accent chair, round coffee table, and decorative artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1a70bb48-78df-412f-bb5b-26092991d40a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-a6e5-75bf-a29f-b0831deab268.webp",
      "image_media": {
        "alt_text": "Balcony view of the community amenities including a pool and seating areas.",
        "public_id": "019f3ced-a6e5-75bf-a29f-b0831deab268",
        "storage_key": "property/6767906449166542/019f3ced-a6e5-75bf-a29f-b0831deab268.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors from your private balcony, with a view of the sparkling pool and lush green spaces.",
      "link": "",
      "alt_text": "Balcony view of the community amenities including a pool and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5e595ddb-5edf-4bc9-8985-bc6629f05bcd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-a3fb-77fd-9830-0874a3ad51c1.webp",
      "image_media": {
        "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
        "public_id": "019f3ced-a3fb-77fd-9830-0874a3ad51c1",
        "storage_key": "property/6767906449166542/019f3ced-a3fb-77fd-9830-0874a3ad51c1.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Beautifully maintained apartment complex featuring a sparkling swimming pool and ample lounge seating, surrounded by lush green lawns and modern buildings.",
      "link": "",
      "alt_text": "Apartment complex with a large swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2bbbe5e-a0c7-42aa-8f8a-771191141e76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-3558-731b-ae98-d4d57e490898.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, chairs, desk, and coffee table.",
        "public_id": "019f3ced-3558-731b-ae98-d4d57e490898",
        "storage_key": "property/6767906449166542/019f3ced-3558-731b-ae98-d4d57e490898.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern living room featuring a plush sofa, comfortable seating, a dedicated workspace, and a stylish coffee table. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with a sofa, chairs, desk, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eda7eb5c-97d4-4fcc-9125-9d40c655512a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-16d5-739f-9b82-53518cd04dff.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white subway tile backsplash.",
        "public_id": "019f3ced-16d5-739f-9b82-53518cd04dff",
        "storage_key": "property/6767906449166542/019f3ced-16d5-739f-9b82-53518cd04dff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore this beautifully appointed kitchen, featuring dark wood cabinetry, a sleek stainless steel appliance suite, and a classic white subway tile backsplash. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a20bb545-c190-40fb-95ee-1a57bdf97ce9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-31ca-768a-8468-58c41f8e5fd5.webp",
      "image_media": {
        "alt_text": "Desk with framed art and chair in a modern apartment living area.",
        "public_id": "019f3ced-31ca-768a-8468-58c41f8e5fd5",
        "storage_key": "property/6767906449166542/019f3ced-31ca-768a-8468-58c41f8e5fd5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A stylish desk with artwork and a comfortable chair, adjacent to a dining area, creating a functional and elegant living space.",
      "link": "",
      "alt_text": "Desk with framed art and chair in a modern apartment living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b76c82ce-f0cd-4e50-ae83-52081d4a6ece",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-1283-746a-aee4-b149d1b2b0aa.webp",
      "image_media": {
        "alt_text": "Spacious living room with a large grey sofa, tufted armchair, coffee table, and a desk area.",
        "public_id": "019f3ced-1283-746a-aee4-b149d1b2b0aa",
        "storage_key": "property/6767906449166542/019f3ced-1283-746a-aee4-b149d1b2b0aa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in our beautifully appointed living spaces, featuring comfortable seating, a stylish coffee table, and a dedicated desk area for your convenience.",
      "link": "",
      "alt_text": "Spacious living room with a large grey sofa, tufted armchair, coffee table, and a desk area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5c29e82a-bf6d-4a07-818c-660fe51be74d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-0d31-72bf-8f84-62dc40bdfb8b.webp",
      "image_media": {
        "alt_text": "Gym with various exercise machines including treadmills, elliptical, and weight machines.",
        "public_id": "019f3ced-0d31-72bf-8f84-62dc40bdfb8b",
        "storage_key": "property/6767906449166542/019f3ced-0d31-72bf-8f84-62dc40bdfb8b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio and weight training equipment for residents.",
      "link": "",
      "alt_text": "Gym with various exercise machines including treadmills, elliptical, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_adb95264-6982-4e53-b504-7a5a8c2b148c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-1098-7788-95c3-948361e0974f.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, free weights, medicine balls, and benches.",
        "public_id": "019f3ced-1098-7788-95c3-948361e0974f",
        "storage_key": "property/6767906449166542/019f3ced-1098-7788-95c3-948361e0974f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide variety of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with weight machines, free weights, medicine balls, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_88dd39ea-8cf6-43b3-a8e1-cf48e2441a1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-0b91-74ca-8c6c-51d53e2fdecb.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, weight machines, and a bench.",
        "public_id": "019f3ced-0b91-74ca-8c6c-51d53e2fdecb",
        "storage_key": "property/6767906449166542/019f3ced-0b91-74ca-8c6c-51d53e2fdecb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and free weights.",
      "link": "",
      "alt_text": "Gym with treadmills, weight machines, and a bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c84d610e-169e-4d53-9d3e-b1a8a51befcd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3ced-0813-7590-b6ec-24f16516c44c.webp",
      "image_media": {
        "alt_text": "Modern clubhouse interior with stylish seating and fireplace.",
        "public_id": "019f3ced-0813-7590-b6ec-24f16516c44c",
        "storage_key": "property/6767906449166542/019f3ced-0813-7590-b6ec-24f16516c44c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover the elegant clubhouse at 152 Northland, featuring comfortable seating areas and a striking fireplace. Perfect for residents to relax and socialize.",
      "link": "",
      "alt_text": "Modern clubhouse interior with stylish seating and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d22aca9b-771d-47c5-98e7-86e0d22d8a8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-fd6b-70c9-bfa4-fce308073e57.webp",
      "image_media": {
        "alt_text": "Community game room with pool table and shuffleboard, large garage-style windows opening to outdoor seating.",
        "public_id": "019f3cec-fd6b-70c9-bfa4-fce308073e57",
        "storage_key": "property/6767906449166542/019f3cec-fd6b-70c9-bfa4-fce308073e57.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy endless entertainment in our community game room, featuring a pool table and shuffleboard. Large garage-style doors open to outdoor seating and views.",
      "link": "",
      "alt_text": "Community game room with pool table and shuffleboard, large garage-style windows opening to outdoor seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63ed9c49-a5c9-4cf2-9ca3-56b9e70c1701",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-f49d-77cc-8dab-6e70f38327c0.webp",
      "image_media": {
        "alt_text": "Entertainment room with a pool table, bar seating, and multiple TVs.",
        "public_id": "019f3cec-f49d-77cc-8dab-6e70f38327c0",
        "storage_key": "property/6767906449166542/019f3cec-f49d-77cc-8dab-6e70f38327c0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy entertainment in the community lounge, featuring a pool table, bar, and large screens for your viewing pleasure.",
      "link": "",
      "alt_text": "Entertainment room with a pool table, bar seating, and multiple TVs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6da9e812-9dce-4cbc-8ebe-24d5b4634816",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-ce96-7195-b4bc-685734967b3d.webp",
      "image_media": {
        "alt_text": "Luxury apartment community lounge area with plush seating and a modern fireplace.",
        "public_id": "019f3cec-ce96-7195-b4bc-685734967b3d",
        "storage_key": "property/6767906449166542/019f3cec-ce96-7195-b4bc-685734967b3d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a sleek fireplace, and elegant decor. Perfect for socializing or quiet contemplation.",
      "link": "",
      "alt_text": "Luxury apartment community lounge area with plush seating and a modern fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_50ccc4af-4d89-46e8-b796-be6139f21122",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-d08a-76d8-adeb-9cabde59d461.webp",
      "image_media": {
        "alt_text": "Luxury lounge area with tufted chairs, a modern fireplace, and large windows overlooking the property.",
        "public_id": "019f3cec-d08a-76d8-adeb-9cabde59d461",
        "storage_key": "property/6767906449166542/019f3cec-d08a-76d8-adeb-9cabde59d461.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed resident lounge, featuring plush seating, a stunning fireplace, and elegant decor. A perfect space for socializing or quiet reflection.",
      "link": "",
      "alt_text": "Luxury lounge area with tufted chairs, a modern fireplace, and large windows overlooking the property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1d54c2b2-31a7-444c-999f-0cb3c74371d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-a1bb-71b8-bc02-f17c0648b2e0.webp",
      "image_media": {
        "alt_text": "Apartment complex with outdoor seating and fire pit",
        "public_id": "019f3cec-a1bb-71b8-bc02-f17c0648b2e0",
        "storage_key": "property/6767906449166542/019f3cec-a1bb-71b8-bc02-f17c0648b2e0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with comfortable seating and a fire pit area at this modern apartment community.",
      "link": "",
      "alt_text": "Apartment complex with outdoor seating and fire pit",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b714f0a-b7f7-4dc2-8649-6d6a870429f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-a3fa-727e-aeb3-07c438a40c2e.webp",
      "image_media": {
        "alt_text": "Modern apartment building entrance with parking lot",
        "public_id": "019f3cec-a3fa-727e-aeb3-07c438a40c2e",
        "storage_key": "property/6767906449166542/019f3cec-a3fa-727e-aeb3-07c438a40c2e.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "View of the main entrance to a modern apartment community, featuring a well-maintained parking lot and landscaped grounds. The building boasts an attractive architectural design with dark roofing and white siding.",
      "link": "",
      "alt_text": "Modern apartment building entrance with parking lot",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c9d9452-28e8-444e-92c2-c2d7969e4338",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-aab8-72ef-bcc3-651cb2a3a502.webp",
      "image_media": {
        "alt_text": "Northland Apartment Homes monument sign with address 152",
        "public_id": "019f3cec-aab8-72ef-bcc3-651cb2a3a502",
        "storage_key": "property/6767906449166542/019f3cec-aab8-72ef-bcc3-651cb2a3a502.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Northland Apartment Homes! This monument sign is prominently displayed at the entrance of the property, showcasing the address and property name.",
      "link": "",
      "alt_text": "Northland Apartment Homes monument sign with address 152",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f1bcc56-2afe-43e6-b02c-091d826b855a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-959a-761f-b650-a98a18696b56.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with white siding and stone accents.",
        "public_id": "019f3cec-959a-761f-b650-a98a18696b56",
        "storage_key": "property/6767906449166542/019f3cec-959a-761f-b650-a98a18696b56.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover the stunning exterior of our community, featuring modern architecture and beautifully landscaped grounds.",
      "link": "",
      "alt_text": "Exterior of a modern apartment building with white siding and stone accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a7e71d4c-3424-4f37-adb6-1ab50094d7d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-8a29-728f-bc74-85bdb4229520.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
        "public_id": "019f3cec-8a29-728f-bc74-85bdb4229520",
        "storage_key": "property/6767906449166542/019f3cec-8a29-728f-bc74-85bdb4229520.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover modern apartment living with stylish exteriors, private balconies, and beautiful landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ea150982-4c64-439e-a2ea-7d3d78f874fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-7850-739b-8c5e-c01ded7bce5d.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit and pink chairs.",
        "public_id": "019f3cec-7850-739b-8c5e-c01ded7bce5d",
        "storage_key": "property/6767906449166542/019f3cec-7850-739b-8c5e-c01ded7bce5d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the outdoor seating area, complete with a cozy fire pit and vibrant pink chairs, perfect for enjoying evenings.",
      "link": "",
      "alt_text": "Outdoor seating area with a fire pit and pink chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_89f5248a-7895-4ea5-a5d2-87078b5897e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-602e-75b0-9af8-0a27d23c63c3.webp",
      "image_media": {
        "alt_text": "Modern apartment complex with a large swimming pool, lounge chairs, and a covered cabana.",
        "public_id": "019f3cec-602e-75b0-9af8-0a27d23c63c3",
        "storage_key": "property/6767906449166542/019f3cec-602e-75b0-9af8-0a27d23c63c3.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool at our apartment community, complete with comfortable lounge seating and a shaded cabana area.",
      "link": "",
      "alt_text": "Modern apartment complex with a large swimming pool, lounge chairs, and a covered cabana.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b30dab90-5801-45a3-88e4-ff447755f196",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-7197-751a-ac09-4bb17e9d4595.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and green lawn.",
        "public_id": "019f3cec-7197-751a-ac09-4bb17e9d4595",
        "storage_key": "property/6767906449166542/019f3cec-7197-751a-ac09-4bb17e9d4595.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained exterior of apartment buildings, showcasing private balconies and a lush green lawn, creating an inviting community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c25d2f71-f407-4b2b-8577-222921f25293",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-74bd-7158-9c32-607e9fa8c9ba.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and manicured lawn.",
        "public_id": "019f3cec-74bd-7158-9c32-607e9fa8c9ba",
        "storage_key": "property/6767906449166542/019f3cec-74bd-7158-9c32-607e9fa8c9ba.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring private balconies and a well-maintained green lawn, showcasing the property's welcoming facade.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies and manicured lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3e987a76-a90f-42b8-94fb-cc3ade036a49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-682c-76e9-888e-7cb7a33874f7.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with picnic table and umbrella, apartment buildings in background.",
        "public_id": "019f3cec-682c-76e9-888e-7cb7a33874f7",
        "storage_key": "property/6767906449166542/019f3cec-682c-76e9-888e-7cb7a33874f7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our community grilling station, complete with multiple grills, a spacious picnic area, and a large umbrella for shade. Perfect for gatherings with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor grilling station with picnic table and umbrella, apartment buildings in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_11445b7e-1243-4830-a783-fc3a50b34406",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-6038-754b-b729-4069acc678ca.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019f3cec-6038-754b-b729-4069acc678ca",
        "storage_key": "property/6767906449166542/019f3cec-6038-754b-b729-4069acc678ca.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and a beautiful backdrop of the apartment community.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7f7d0751-9fa1-48c1-a48f-ea65bc36faca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-47cf-7069-8575-c7474ea7061f.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019f3cec-47cf-7069-8575-c7474ea7061f",
        "storage_key": "property/6767906449166542/019f3cec-47cf-7069-8575-c7474ea7061f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a beautiful view of the surrounding apartment buildings.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_93488a7a-fc22-4990-a7ef-4cfee18494c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-20a3-73b8-8641-864f41d8f6db.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with built-in lounge chairs and surrounding apartment buildings.",
        "public_id": "019f3cec-20a3-73b8-8641-864f41d8f6db",
        "storage_key": "property/6767906449166542/019f3cec-20a3-73b8-8641-864f41d8f6db.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, featuring comfortable built-in loungers perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with built-in lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e5f537e1-cdd5-4b10-8502-c50c8080b2cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019f3cec-23f0-74ab-a41b-2f50d5d5781b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with fountains and lounge chairs in front of apartment buildings.",
        "public_id": "019f3cec-23f0-74ab-a41b-2f50d5d5781b",
        "storage_key": "property/6767906449166542/019f3cec-23f0-74ab-a41b-2f50d5d5781b.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with fountains and comfortable lounge chairs for relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with fountains and lounge chairs in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_2346af11-a84c-4a2d-82ab-803f246da5f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "6501 NW Barry Rd, Kansas City, MO 64154, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken sandwiches and hot fries. They highlight the fast service, even during busy periods, and the efficient drive-thru design. They also like the friendly and polite staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-9b79-7155-a08f-0116f061e133.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-9b79-7155-a08f-0116f061e133",
        "storage_key": "property/6767906449166542/019cfb4d-9b79-7155-a08f-0116f061e133.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/mo/i-29-barry-road?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2275380395166734837&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "39.2461924",
      "poi_longitude": "-94.6539813",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-587-0411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeYVmXkhfwIcR9RnN9mnGkx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_d5a56f34-3971-42a5-b578-aa043cc80185",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "8051 Roanridge Rd, Kansas City, MO 64151, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and pork chops, along with warm rolls and cinnamon butter. They highlight the generous portions, reasonable prices, and lively atmosphere. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-d893-7771-aeb3-12df447ad909.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-d893-7771-aeb3-12df447ad909",
        "storage_key": "property/6767906449166542/019cfb4d-d893-7771-aeb3-12df447ad909.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/missouri/kansas-city?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=16198406781598789157&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "39.2412883",
      "poi_longitude": "-94.656915",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-741-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ7mtr0VfwIcRJW55ICVNzOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_bd5d804d-92be-4975-a80e-0e4c18e564e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "8771 N Ambassador Dr, Kansas City, MO 64154, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken tenders and fantastic Cane's sauce. They also highlight the friendly staff and the fresh, hot food.\n\nSome reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-d955-71f0-9d4b-3ae4488edcc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-d955-71f0-9d4b-3ae4488edcc8",
        "storage_key": "property/6767906449166542/019cfb4d-d955-71f0-9d4b-3ae4488edcc8.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/mo/kansas-city/8771-n.-ambassador-dr.",
      "poi_directions_map_url": "https://maps.google.com/?cid=15636708610982546926&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "39.2567669",
      "poi_longitude": "-94.6489296",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-584-0502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo9IZtDNfwIcR7g3ohaK_ANk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_90c9a959-080f-4a09-8873-adf9256a716d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "8800 N Skyview Ave, Kansas City, MO 64154, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of food options, including steak, ham, and homemade tamales. They also highlight the affordable prices, especially for the early bird special, and the friendly staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-d8cd-721c-b10d-18824bccec73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-d8cd-721c-b10d-18824bccec73",
        "storage_key": "property/6767906449166542/019cfb4d-d8cd-721c-b10d-18824bccec73.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/location-detail/2605/golden-corral-n-skyview-ave/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=2605",
      "poi_directions_map_url": "https://maps.google.com/?cid=9529424459634360752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "39.2553379",
      "poi_longitude": "-94.650344",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-505-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQS4S8S9fwIcRsMFslg5RP4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_5ec5efc0-0016-423a-8685-b4227ba0d4f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Main Event Kansas City North",
      "poi_type": "Restaurants",
      "poi_address": "8081 NW Roanridge Rd., Kansas City, MO 64151, USA",
      "poi_short_description": "Pizza, wings, laser-tag eatery featuring bowling lanes and a full-service bar.",
      "poi_long_description": "People say this restaurant offers bowling, arcade games, and laser tag. They also highlight the fun atmosphere and friendly staff.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-d8c2-77f2-b96d-ed247f419609.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-d8c2-77f2-b96d-ed247f419609",
        "storage_key": "property/6767906449166542/019cfb4d-d8c2-77f2-b96d-ed247f419609.webp",
        "width": 1280,
        "height": 708
      },
      "poi_business_url": "http://www.mainevent.com/locations/missouri/kansas-city-north",
      "poi_directions_map_url": "https://maps.google.com/?cid=15555059811509003358&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-kansas-city-north",
      "poi_latitude": "39.2417979",
      "poi_longitude": "-94.654988",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-281-2020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHVdq10VfwIcRXuTy_Hus3tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_40566b3a-36e1-4bd4-ac8d-86ab72dd52cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Menards",
      "poi_type": "Shopping & Retail",
      "poi_address": "3701 NW 90th St, Kansas City, MO 64154, USA",
      "poi_short_description": "Home improvement chain with assorted building materials, tools, gardening supplies & appliances.",
      "poi_long_description": "People say this home improvement store offers great prices and a huge selection of products, including carpet shampoo cleaner rentals and chest freezers. They also highlight the convenience of having items loaded into their vehicles.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-d8bc-7080-a396-a448f3b2823b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-d8bc-7080-a396-a448f3b2823b",
        "storage_key": "property/6767906449166542/019cfb4d-d8bc-7080-a396-a448f3b2823b.webp",
        "width": 1280,
        "height": 899
      },
      "poi_business_url": "https://www.menards.com/store-details/store.html?store=3342&utm_source=localcard&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=7106698464765649376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "menards",
      "poi_latitude": "39.255619",
      "poi_longitude": "-94.6228408",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-436-0723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdf8-7038-ab76-4d70d9b89f5e",
        "storage_key": "property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpbvzFcRYwIcR4KErzpkQoGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_cb5cc26d-edb0-4b7a-bd7c-8446e0d72c59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "4949 NW Old Pike Rd, Gladstone, MO 64118, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products, including plants and flowers, for home projects. They also highlight the helpful, knowledgeable, and friendly staff who go above and beyond to assist customers.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-d97c-72bd-a529-0a91676cdd95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-d97c-72bd-a529-0a91676cdd95",
        "storage_key": "property/6767906449166542/019cfb4d-d97c-72bd-a529-0a91676cdd95.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Gladstone/MO/Gladstone/64118/3008?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12882275819926390752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "39.1846693",
      "poi_longitude": "-94.582194",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-459-9950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdf8-7038-ab76-4d70d9b89f5e",
        "storage_key": "property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa0rCqHT3wIcR4AdR4ZoJx7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_128f6f3d-bf0d-41b0-bb8b-901bcbad3b82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Riverside Red X",
      "poi_type": "Shopping & Retail",
      "poi_address": "2101 NW Platte Rd, Riverside, MO 64150, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-d8fe-757c-abc8-3fdcbd2daaf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-d8fe-757c-abc8-3fdcbd2daaf1",
        "storage_key": "property/6767906449166542/019cfb4d-d8fe-757c-abc8-3fdcbd2daaf1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://riversideredx.com/?y_source=1_OTU4MTI1MC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7234847896505060890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "riverside-red-x",
      "poi_latitude": "39.1680166",
      "poi_longitude": "-94.6057217",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-741-3377",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdee-7315-ac73-348cc654548a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdee-7315-ac73-348cc654548a",
        "storage_key": "property/6767906449166542/019cfb4d-bdee-7315-ac73-348cc654548a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQRXrmuD2wIcRGo4qe9RXZ2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_72ffb2ba-5e80-41e6-9c45-1d1853b9c385",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "8301 N St Clair Ave, Kansas City, MO 64151, USA",
      "poi_short_description": "Neighborhood chain grocery store offering a range of produce, meats, seafood, and baked goods.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meat, and other products, including a good selection of liquor and beer. They also highlight the clean and well-stocked store, and the friendly, helpful, and courteous staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-a14a-7421-a6fc-7fd5db05c1fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a14a-7421-a6fc-7fd5db05c1fc",
        "storage_key": "property/6767906449166542/019cfb4d-a14a-7421-a6fc-7fd5db05c1fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=77&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5363076948978843234&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "39.2452729",
      "poi_longitude": "-94.6457346",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-505-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdee-7315-ac73-348cc654548a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdee-7315-ac73-348cc654548a",
        "storage_key": "property/6767906449166542/019cfb4d-bdee-7315-ac73-348cc654548a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFyOPOktfwIcRYj74_hF6bUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2ed1dbfd-261d-400b-abba-cfda75636272",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Park University",
      "poi_type": "Education",
      "poi_address": "8700 NW River Park Dr, Parkville, MO 64152, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-a7aa-7105-86ae-17035cef4be3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a7aa-7105-86ae-17035cef4be3",
        "storage_key": "property/6767906449166542/019cfb4d-a7aa-7105-86ae-17035cef4be3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.park.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5865549962662049872&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "park-university",
      "poi_latitude": "39.191576",
      "poi_longitude": "-94.6755573",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 816-741-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-be00-761e-81e1-7f8a7f3bc920",
        "storage_key": "property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt7EsC671wIcRUPjGMJ2eZlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1c7a995b-34da-47d3-b5da-9120e2a3db83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Metropolitan Community College - Maple Woods",
      "poi_type": "Education",
      "poi_address": "2601 NE Barry Rd, Kansas City, MO 64156, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-a660-73e3-871f-11f2828a3082.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a660-73e3-871f-11f2828a3082",
        "storage_key": "property/6767906449166542/019cfb4d-a660-73e3-871f-11f2828a3082.webp",
        "width": 1200,
        "height": 803
      },
      "poi_business_url": "https://mcckc.edu/maplewoods",
      "poi_directions_map_url": "https://maps.google.com/?cid=9374804838064555436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metropolitan-community-college---maple-woods",
      "poi_latitude": "39.246921",
      "poi_longitude": "-94.5478501",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-604-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-be00-761e-81e1-7f8a7f3bc920",
        "storage_key": "property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsz0_u-5XwIcRrIVzk1T_GYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d7bf8dc9-f85e-4864-91c4-fd43d4ddac23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Mid-Continent Public Library - Green Hills Library Center",
      "poi_type": "Education",
      "poi_address": "8581 N Green Hills Rd, Kansas City, MO 64154, USA",
      "poi_short_description": "Family-friendly library providing books, DVDs and programs, as well as meeting rooms and study spaces.",
      "poi_long_description": "People say this library offers a wide selection of books, quiet study areas, and a dedicated children's area. They highlight the convenient location, the availability of resources like computers and printing services, and the presence of a cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-dc38-745a-8070-fcbf23d23184.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-dc38-745a-8070-fcbf23d23184",
        "storage_key": "property/6767906449166542/019cfb4d-dc38-745a-8070-fcbf23d23184.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mymcpl.org/locations/green-hills-library-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9022124123893074582&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mid-continent-public-library---green-hills-library-center",
      "poi_latitude": "39.2495521",
      "poi_longitude": "-94.6303676",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-741-9011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-be00-761e-81e1-7f8a7f3bc920",
        "storage_key": "property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaSMHM4dZwIcRlgoh5BYGNX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_96c4ac91-303a-43cf-a66e-2fc54ddd6e7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Springs Aquatic Center",
      "poi_type": "Entertainment",
      "poi_address": "9400 N Congress Ave, Kansas City, MO 64153, USA",
      "poi_short_description": "Seasonal swimming complex featuring pools, plus a leisure area with a lazy river & water slides.",
      "poi_long_description": "Seasonal swimming complex featuring pools, plus a leisure area with a lazy river & water slides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-dc9e-75dc-b9a6-45669c887b95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-dc9e-75dc-b9a6-45669c887b95",
        "storage_key": "property/6767906449166542/019cfb4d-dc9e-75dc-b9a6-45669c887b95.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/the-springs-water-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10420557508559265262&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "springs-aquatic-center",
      "poi_latitude": "39.26326",
      "poi_longitude": "-94.669313",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-513-7860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfd-74fa-b2b9-0a1271f5b873",
        "storage_key": "property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAc_7MxlfwIcR7l0089dBnZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_fe788d34-e512-4ed7-83e7-9513e567d769",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Kansas City Northern Railroad",
      "poi_type": "Entertainment",
      "poi_address": "6060 NW Waukomis Dr, Kansas City, MO 64151, USA",
      "poi_short_description": "Miniature railway in Frank Vaydik Park open weekends May–Sep for rides around a 1/2-mi. track.",
      "poi_long_description": "People say this museum offers a fun train ride, a small playground, and plenty of room to play. They highlight the affordable price, the family-friendly atmosphere, and the ongoing expansion of the track and facilities. They also like the friendly and helpful volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-dcf1-73ba-ab80-a8bce1114e31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-dcf1-73ba-ab80-a8bce1114e31",
        "storage_key": "property/6767906449166542/019cfb4d-dcf1-73ba-ab80-a8bce1114e31.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.kcnrr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3228289762664381209&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kansas-city-northern-railroad",
      "poi_latitude": "39.2039529",
      "poi_longitude": "-94.611023",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-746-5663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-c10e-75e6-b539-9bb7906dd0f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-c10e-75e6-b539-9bb7906dd0f5",
        "storage_key": "property/6767906449166542/019cfb4d-c10e-75e6-b539-9bb7906dd0f5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIyxGLEn2wIcRGfujV28wzSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1b1eecd6-edbb-41ed-aa96-f2b31c68cc8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Shoal Creek Living History Museum",
      "poi_type": "Entertainment",
      "poi_address": "7000 NE Barry Rd, Kansas City, MO 64156, USA",
      "poi_short_description": "An 80-acre park with authentic buildings documenting Missouri history, plus reenactments & trails.",
      "poi_long_description": "People say this history museum offers a glimpse into the past with well-maintained buildings and informative signs. They highlight the enjoyable walks, the opportunity to see bison grazing in the pasture, and the beautiful setting for photography. They also like the free admission and the family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-b25f-76d2-934b-7bde85b0e345.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-b25f-76d2-934b-7bde85b0e345",
        "storage_key": "property/6767906449166542/019cfb4d-b25f-76d2-934b-7bde85b0e345.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://shoalcreeklivinghistorymuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7039840035552825463&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shoal-creek-living-history-museum",
      "poi_latitude": "39.252643",
      "poi_longitude": "-94.5015404",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 816-792-2655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-c10e-75e6-b539-9bb7906dd0f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-c10e-75e6-b539-9bb7906dd0f5",
        "storage_key": "property/6767906449166542/019cfb4d-c10e-75e6-b539-9bb7906dd0f5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmVzqC8FXwIcRdxCzsjaJsmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_37e64ec7-0447-42f8-9989-afe776bcc2b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Fred and Shirley Pryor YMCA Challenger Sports Complex",
      "poi_type": "Entertainment",
      "poi_address": "2100 NW 87th Terrace, Kansas City, MO 64154, USA",
      "poi_short_description": "Park featuring a rubberized baseball field and areas for soccer and football.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-dd05-711a-889d-7544a53228e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-dd05-711a-889d-7544a53228e5",
        "storage_key": "property/6767906449166542/019cfb4d-dd05-711a-889d-7544a53228e5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://kansascityymca.org/programs/adaptive-challenger/sports-complex",
      "poi_directions_map_url": "https://maps.google.com/?cid=902892512523238543&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fred-and-shirley-pryor-ymca-challenger-sports-complex",
      "poi_latitude": "39.2535262",
      "poi_longitude": "-94.6062909",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-e961-74fd-b66b-dcabf3969d2c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-e961-74fd-b66b-dcabf3969d2c",
        "storage_key": "property/6767906449166542/019cfb4d-e961-74fd-b66b-dcabf3969d2c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDbrrrPVYwIcRj7xO1_S3hww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_4dc54a55-3a8b-4126-a4a0-d6f16a9e4d02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Breckon Sports Center",
      "poi_type": "Entertainment",
      "poi_address": "1325 E 6th St, Parkville, MO 64152, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-dd37-72fe-b310-37c0fcc00146.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-dd37-72fe-b310-37c0fcc00146",
        "storage_key": "property/6767906449166542/019cfb4d-dd37-72fe-b310-37c0fcc00146.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9891749401602867982&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "breckon-sports-center",
      "poi_latitude": "39.191622",
      "poi_longitude": "-94.6791211",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-584-5425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfd-74fa-b2b9-0a1271f5b873",
        "storage_key": "property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-g4Cqz1wIcRDsO4CayNRok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_3c1fa718-3c9e-416a-a6d3-d12694cacdcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "470 NE Barry Rd, Kansas City, MO 64155, USA",
      "poi_short_description": "Gym with affordable memberships offering a circuit-training area and cardio machines.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and weights. They also highlight the friendly and helpful staff, and the clean environment.\n\nOther reviews mention the gym can be closed unexpectedly.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-ae33-7757-8ac5-7019cd26a8e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-ae33-7757-8ac5-7019cd26a8e5",
        "storage_key": "property/6767906449166542/019cfb4d-ae33-7757-8ac5-7019cd26a8e5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/kansas-city-north-oak-mo?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=3306209639745088981&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.2491588",
      "poi_longitude": "-94.5732824",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-420-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfd-74fa-b2b9-0a1271f5b873",
        "storage_key": "property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTSCaMhFYwIcR1W36eSYE4i0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8120ea68-e33d-4e8c-a109-0d7049235c3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Platte County Community Center South-YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8875 Clark Ave, Parkville, MO 64152, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "People say this gym offers a wide variety of classes, state-of-the-art equipment, and a walking track, as well as amenities like a pool, hot tub, steam room, and sauna. They highlight the friendly and welcoming atmosphere, and the engaging and motivating instructors. They also like the clean and spacious facility, and the helpful and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-dd5f-7622-8ca7-a355e83d338b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-dd5f-7622-8ca7-a355e83d338b",
        "storage_key": "property/6767906449166542/019cfb4d-dd5f-7622-8ca7-a355e83d338b.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "https://kansascityymca.org/locations/platte-county-south",
      "poi_directions_map_url": "https://maps.google.com/?cid=13890440795864388858&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "platte-county-community-center-south-ymca",
      "poi_latitude": "39.2063569",
      "poi_longitude": "-94.6844749",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 816-505-2622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfd-74fa-b2b9-0a1271f5b873",
        "storage_key": "property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU3Vmj5_1wIcR-lQXI0_CxMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bbc59b11-bb67-4aaa-8cae-57b88d90dd76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Mercury Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "10551 N Ambassador Dr, Kansas City, MO 64153, USA",
      "poi_short_description": "Gym featuring classes and tumbling, plus a 25,000-square-foot facility.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-dd58-76df-b72f-353d7efd9aca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-dd58-76df-b72f-353d7efd9aca",
        "storage_key": "property/6767906449166542/019cfb4d-dd58-76df-b72f-353d7efd9aca.webp",
        "width": 487,
        "height": 288
      },
      "poi_business_url": "http://mercurygymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3496995816491958630&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercury-gymnastics",
      "poi_latitude": "39.284875",
      "poi_longitude": "-94.6742389",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-880-9996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-be00-761e-81e1-7f8a7f3bc920",
        "storage_key": "property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw-oexe1ewIcRZsEHzyrThzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_44e5bd9b-495d-4cb7-98b7-9470b146ac79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "EDGE Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "5050 NW Gateway Ave, Riverside, MO 64150, USA",
      "poi_short_description": "Gymnastics center offering classes, open gym, and field trips, plus a preschool area.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-ded0-7574-8f44-3c325218a101.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-ded0-7574-8f44-3c325218a101",
        "storage_key": "property/6767906449166542/019cfb4d-ded0-7574-8f44-3c325218a101.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://edgetc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17134074283611486151&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edge-gymnastics",
      "poi_latitude": "39.18445579999999",
      "poi_longitude": "-94.6138458",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-587-2242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-be00-761e-81e1-7f8a7f3bc920",
        "storage_key": "property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHwF2Yvf2wIcRx3fR3cd1yO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_677283de-6b86-4e78-b9e3-97da9b5638ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Eagle Animal Hospital and Pet Resort",
      "poi_type": "Health and Wellness",
      "poi_address": "4825 NW Gateway Ave, Riverside, MO 64150, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-de84-731b-8a1f-61579c684c2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-de84-731b-8a1f-61579c684c2c",
        "storage_key": "property/6767906449166542/019cfb4d-de84-731b-8a1f-61579c684c2c.webp",
        "width": 424,
        "height": 284
      },
      "poi_business_url": "https://www.eagleanimalhospital.com/locations/riverside?y_source=1_MjYwNTQ0MzEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16885374695865630411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eagle-animal-hospital-and-pet-resort",
      "poi_latitude": "39.18248639999999",
      "poi_longitude": "-94.6128436",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-741-2345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfd-74fa-b2b9-0a1271f5b873",
        "storage_key": "property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fdEI_r2wIcRy75wxtLmVOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_9b82d2e6-a258-462a-96f0-e69cad6f0133",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "L’acqua Nails and Lashes - Nail Salon Kansas City Mo",
      "poi_type": "Health and Wellness",
      "poi_address": "4155 N Mulberry Dr, Kansas City, MO 64116, USA",
      "poi_short_description": "Nail salon in the Village at Briarcliff offering manicures, pedicures, and nail art.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-df6d-770d-bf43-9f28d226c884.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-df6d-770d-bf43-9f28d226c884",
        "storage_key": "property/6767906449166542/019cfb4d-df6d-770d-bf43-9f28d226c884.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://lacquanailsandlashes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2339321968315265261&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lacqua-nails-and-lashes---nail-salon-kansas-city-mo",
      "poi_latitude": "39.1696867",
      "poi_longitude": "-94.5980521",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-326-8625",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfd-74fa-b2b9-0a1271f5b873",
        "storage_key": "property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ24JmYJP3wIcR7fCymO_wdiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_efaf0f03-41d3-442e-877d-f565a2f243ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Salon Inspire",
      "poi_type": "Health and Wellness",
      "poi_address": "129 NE 91 St, Kansas City, MO 64155, USA",
      "poi_short_description": "Friendly, welcoming, relaxed salon offering a variety of haircuts, blowouts, coloring, extensions and scalp massages, as well as pedicures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-e118-76d9-8bd9-7c7bf425a893.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-e118-76d9-8bd9-7c7bf425a893",
        "storage_key": "property/6767906449166542/019cfb4d-e118-76d9-8bd9-7c7bf425a893.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://saloninspirekc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13730457618670501898&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salon-inspire",
      "poi_latitude": "39.2591553",
      "poi_longitude": "-94.5783504",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-216-7726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfd-74fa-b2b9-0a1271f5b873",
        "storage_key": "property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6w5ieDlYwIcRCkBpBHVijL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_4ea792aa-fe70-455d-b7c5-34c78d607fe2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Gladstone Animal Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "7915 N Oak Trafficway, Gladstone, MO 64118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-e140-710f-98e0-ed35e274c518.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-e140-710f-98e0-ed35e274c518",
        "storage_key": "property/6767906449166542/019cfb4d-e140-710f-98e0-ed35e274c518.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://gladvets.com/?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=6003131147656611248&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gladstone-animal-clinic",
      "poi_latitude": "39.2383909",
      "poi_longitude": "-94.5752932",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-436-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfd-74fa-b2b9-0a1271f5b873",
        "storage_key": "property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVvqkOX3wIcRsMUnDPlnT1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_56ddd23f-77ff-4843-be06-6cfcd51edcef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Saint Luke's North Hospital-Barry Road",
      "poi_type": "Health and Wellness",
      "poi_address": "5830 NW Barry Rd, Kansas City, MO 64154, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-ac8d-73cc-bd5a-b4145d4f24cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-ac8d-73cc-bd5a-b4145d4f24cc",
        "storage_key": "property/6767906449166542/019cfb4d-ac8d-73cc-bd5a-b4145d4f24cc.webp",
        "width": 1280,
        "height": 928
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-north-hospital-barry-road?utm_source=yext&utm_medium=local_listing&utm_campaign=yext_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17032396065128644234&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-lukes-north-hospital-barry-road",
      "poi_latitude": "39.24887",
      "poi_longitude": "-94.6481735",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-891-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-c109-70c0-8173-ca88bc31ff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-c109-70c0-8173-ca88bc31ff42",
        "storage_key": "property/6767906449166542/019cfb4d-c109-70c0-8173-ca88bc31ff42.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJH88eiDVfwIcRiv7Az_o5X-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b1b51be4-2b00-47d7-b252-c27475318439",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Kindred Hospital Northland",
      "poi_type": "Health and Wellness",
      "poi_address": "500 NW 68th St, Kansas City, MO 64118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-e166-704f-ade2-ee00206eaedd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-e166-704f-ade2-ee00206eaedd",
        "storage_key": "property/6767906449166542/019cfb4d-e166-704f-ade2-ee00206eaedd.webp",
        "width": 800,
        "height": 530
      },
      "poi_business_url": "https://www.kindredhospitals.com/locations/missouri/northland",
      "poi_directions_map_url": "https://maps.google.com/?cid=11634295283231026387&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kindred-hospital-northland",
      "poi_latitude": "39.2194532",
      "poi_longitude": "-94.5872855",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-420-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-c109-70c0-8173-ca88bc31ff42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-c109-70c0-8173-ca88bc31ff42",
        "storage_key": "property/6767906449166542/019cfb4d-c109-70c0-8173-ca88bc31ff42.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bIxbcP3wIcR0-z8QOtRdaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a2158bb5-f9d3-43db-9049-989ad9739a0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Penguin Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4124 NE Vivion Rd, Kansas City, MO 64119, USA",
      "poi_short_description": "Whimsical public park featuring giant animal sculptures, a picnic shelter & barbecue grills.",
      "poi_long_description": "Visitors say this city park has a fun playground with swings, slides, and climbing structures, as well as unique animal sculptures and walking trails. They also highlight the clean restrooms, plentiful picnic tables, and the inclusive playground equipment for children with disabilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-e2a3-7046-a0dc-71dbd9ed21e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-e2a3-7046-a0dc-71dbd9ed21e0",
        "storage_key": "property/6767906449166542/019cfb4d-e2a3-7046-a0dc-71dbd9ed21e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kcparks.org/park/penguin-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17185212368197134391&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "penguin-park",
      "poi_latitude": "39.1875038",
      "poi_longitude": "-94.5310444",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-be3a-70ca-b887-addf07ef7395.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-be3a-70ca-b887-addf07ef7395",
        "storage_key": "property/6767906449166542/019cfb4d-be3a-70ca-b887-addf07ef7395.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn4kx8635wIcRNygKBJkjfu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9d3c73b3-a59b-4f83-9198-ec24af1b69be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Parkville Nature Sanctuary",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 E 12 St, Parkville, MO 64152, USA",
      "poi_short_description": "Quiet, 115-acre area featuring hiking trails, creeks and waterfalls.",
      "poi_long_description": "People say this park offers beautiful trails with varying degrees of difficulty, perfect for hiking and enjoying nature. They highlight the scenic views, including waterfalls, streams, and a dam, as well as the peaceful and relaxing atmosphere. They also like the well-maintained trails, the availability of benches and a boardwalk overlook, and the historical sights like an old jail cell and grain cellar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-b216-774f-8157-f926359dc96a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-b216-774f-8157-f926359dc96a",
        "storage_key": "property/6767906449166542/019cfb4d-b216-774f-8157-f926359dc96a.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://parkvillemo.gov/nature-sanctuary/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10846315822268828429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "parkville-nature-sanctuary",
      "poi_latitude": "39.1949689",
      "poi_longitude": "-94.6810636",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 816-741-7676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-be3a-70ca-b887-addf07ef7395.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-be3a-70ca-b887-addf07ef7395",
        "storage_key": "property/6767906449166542/019cfb4d-be3a-70ca-b887-addf07ef7395.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0a2dTa_1wIcRDUsILMbahZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3400e683-5062-4b8f-b76a-b723b8ba96ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Shoal Creek Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8905 Shoal Creek Pkwy, Kansas City, MO 64157, USA",
      "poi_short_description": "Public, par-71 course designed by Steve Wolfard featuring elevation changes and other challenges.",
      "poi_long_description": "People say this golf course is beautiful, challenging, and well-maintained. They highlight the course has a nice layout with interesting holes and ample-sized greens, and the fairways and tees are in good shape. They also like the friendly and professional staff, and the well-maintained carts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-e29f-7679-8770-ea4162ec7d5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-e29f-7679-8770-ea4162ec7d5e",
        "storage_key": "property/6767906449166542/019cfb4d-e29f-7679-8770-ea4162ec7d5e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://shoalcreekgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3060025617577092222&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shoal-creek-golf-course",
      "poi_latitude": "39.2553169",
      "poi_longitude": "-94.4860135",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-407-7242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-e969-736e-937a-412907d14ea3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-e969-736e-937a-412907d14ea3",
        "storage_key": "property/6767906449166542/019cfb4d-e969-736e-937a-412907d14ea3.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-QpC5wxWwIcRfiRHIxZldyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_281d2ab4-6ce4-4b35-a065-c96c05384c44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Happy Rock Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7565 NE Antioch Rd, Gladstone, MO 64119, USA",
      "poi_short_description": "Clean park, known for its playgrounds and well-kept trails.",
      "poi_long_description": "Visitors say this park offers paved trails that are great for walking, jogging, and biking, as well as fields for playing soccer, baseball, and tennis. They also highlight the park's clean environment and peaceful atmosphere, making it an ideal spot for exercise and enjoying nature.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-e2ec-7252-bbe5-c6b99eb5c359.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-e2ec-7252-bbe5-c6b99eb5c359",
        "storage_key": "property/6767906449166542/019cfb4d-e2ec-7252-bbe5-c6b99eb5c359.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gladstone.mo.us/Recreation/parks.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=13819278990336049365&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "happy-rock-park",
      "poi_latitude": "39.230415",
      "poi_longitude": "-94.5345898",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-423-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-be3a-70ca-b887-addf07ef7395.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-be3a-70ca-b887-addf07ef7395",
        "storage_key": "property/6767906449166542/019cfb4d-be3a-70ca-b887-addf07ef7395.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52fxjtD5wIcR1cD_Jgbxx78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_eb2b8b02-cb7b-417c-974b-64f56f0657f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Tiffany Greens Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5900 NW Tiffany Springs Pkwy, Kansas City, MO 64154, USA",
      "poi_short_description": "Opened in 1999, this golf course with a pub & clubhouse offers lessons, tournaments & club fittings.",
      "poi_long_description": "People say this golf course offers a challenging layout with split fairways and water hazards, and the tee boxes are well-maintained.\n\nOther reviews mention the greens and fairways can be in poor condition.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-e2bc-700f-aa03-36a281fc868c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-e2bc-700f-aa03-36a281fc868c",
        "storage_key": "property/6767906449166542/019cfb4d-e2bc-700f-aa03-36a281fc868c.webp",
        "width": 1000,
        "height": 692
      },
      "poi_business_url": "http://www.tiffanygreensgolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18171086618110436744&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tiffany-greens-golf-club",
      "poi_latitude": "39.2742721",
      "poi_longitude": "-94.6459609",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-880-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-e969-736e-937a-412907d14ea3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-e969-736e-937a-412907d14ea3",
        "storage_key": "property/6767906449166542/019cfb4d-e969-736e-937a-412907d14ea3.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJWYhuACpZwIcRiKVTLwGrLPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_15966ef2-672b-4a02-acc2-f80dff14e76f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Kansas City Northern Knights R/C Airfield",
      "poi_type": "Transportation & Transit",
      "poi_address": "NE 96th St, Kansas City, MO 64157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-e44e-71db-b01f-9a66ae79a6dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-e44e-71db-b01f-9a66ae79a6dc",
        "storage_key": "property/6767906449166542/019cfb4d-e44e-71db-b01f-9a66ae79a6dc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.northernknights.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7305118864964463918&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kansas-city-northern-knights-rc-airfield",
      "poi_latitude": "39.26354329999999",
      "poi_longitude": "-94.496541",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-c14b-7406-a083-3b8cdbed2d1d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-c14b-7406-a083-3b8cdbed2d1d",
        "storage_key": "property/6767906449166542/019cfb4d-c14b-7406-a083-3b8cdbed2d1d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJt0rUw2hWwIcRLi02TOf-YGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airstrip"
    },
    {
      "id": "custom_f00f9d79-6bc5-445e-b717-308eeaedb462",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Meta Data Center - Kansas City (KCM)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1800 NW 128 St, Kansas City, MO 64165, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6167808881323294431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meta-data-center---kansas-city-kcm",
      "poi_latitude": "39.3248735",
      "poi_longitude": "-94.6009517",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-327-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfd-74fa-b2b9-0a1271f5b873",
        "storage_key": "property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL503cQBbwIcR3z7GxX91mFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8de7ef6f-19c0-46b1-9c02-24ac04d9061c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Coperion",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7901 NW 107th Terrace, Kansas City, MO 64153, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-e407-74c3-810b-c7f792e4deee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-e407-74c3-810b-c7f792e4deee",
        "storage_key": "property/6767906449166542/019cfb4d-e407-74c3-810b-c7f792e4deee.webp",
        "width": 1206,
        "height": 668
      },
      "poi_business_url": "http://www.coperion.com/fhn",
      "poi_directions_map_url": "https://maps.google.com/?cid=6747828070646791970&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "coperion",
      "poi_latitude": "39.2876007",
      "poi_longitude": "-94.6719577",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-891-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfd-74fa-b2b9-0a1271f5b873",
        "storage_key": "property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_bckuxewIcRIr9P9OAZpV0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_176f0bfe-bdbd-4ab9-a549-662bce72db25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Gladstone City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7010 N Holmes St, Gladstone, MO 64118, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-e588-777e-93eb-c1f69eb0d3f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-e588-777e-93eb-c1f69eb0d3f2",
        "storage_key": "property/6767906449166542/019cfb4d-e588-777e-93eb-c1f69eb0d3f2.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.gladstone.mo.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7875155584935402565&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gladstone-city-hall",
      "poi_latitude": "39.2214852",
      "poi_longitude": "-94.5718113",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-436-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-eac7-7193-8fd9-1da22fde1d7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-eac7-7193-8fd9-1da22fde1d7f",
        "storage_key": "property/6767906449166542/019cfb4d-eac7-7193-8fd9-1da22fde1d7f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQZSlsPr3wIcRRRwCt0csSm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_3f704fd4-6f29-4744-b201-d38587e83dd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Marlen International, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4780 NW 41st St #100, Riverside, MO 64150, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-e557-7049-af80-fd85f07cb7b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-e557-7049-af80-fd85f07cb7b1",
        "storage_key": "property/6767906449166542/019cfb4d-e557-7049-af80-fd85f07cb7b1.webp",
        "width": 1278,
        "height": 296
      },
      "poi_business_url": "http://www.marlen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10119636739528289679&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "marlen-international-inc",
      "poi_latitude": "39.1690635",
      "poi_longitude": "-94.6360015",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-888-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfd-74fa-b2b9-0a1271f5b873",
        "storage_key": "property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2Kn6Zn2wIcRj22Tm_8rcIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6a27ad3e-7ab2-4e5b-b58e-5ac3b158f9f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Haldex Brake Products Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10930 N Pomona Ave, Kansas City, MO 64153, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.haldex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12009686585371356639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haldex-brake-products-corporation",
      "poi_latitude": "39.2920401",
      "poi_longitude": "-94.6727477",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-643-2374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfd-74fa-b2b9-0a1271f5b873",
        "storage_key": "property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfi7p5NewIcR323VwFH6qqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_01b7445b-057f-4ce1-bf34-2f7186ad1f12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Pathfinder Elementary",
      "poi_type": "Education",
      "poi_address": "1951 NW 87th Terrace, Kansas City, MO 64154, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-b6e2-75b8-b6da-bf7e2c01368b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b6e2-75b8-b6da-bf7e2c01368b",
        "storage_key": "property/6767906449166542/019d7915-b6e2-75b8-b6da-bf7e2c01368b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://pathfinder.plattecountyschooldistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10840549968774149955&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pathfinder-elementary",
      "poi_latitude": "39.2513925",
      "poi_longitude": "-94.6041404",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 816-436-6670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-be00-761e-81e1-7f8a7f3bc920",
        "storage_key": "property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjR62W_VYwIcRQ7enysJecZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_8d931a96-c027-4d89-9539-a1c0c49fa76f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Platte Purchase Middle School",
      "poi_type": "Education",
      "poi_address": "9400 N Platte Purchase Dr, Kansas City, MO 64155, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-b949-70bc-a0db-0e3c5bc3a5f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b949-70bc-a0db-0e3c5bc3a5f5",
        "storage_key": "property/6767906449166542/019d7915-b949-70bc-a0db-0e3c5bc3a5f5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://plattepurchase.plattecountyschooldistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6265140905458496396&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "platte-purchase-middle-school",
      "poi_latitude": "39.2632573",
      "poi_longitude": "-94.6053564",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 816-436-1433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-be00-761e-81e1-7f8a7f3bc920",
        "storage_key": "property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdd1ddpFZwIcRjHOfmXVA8lY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_938a3d44-a4c6-4780-a72a-fce8e4c4340b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Platte County High School",
      "poi_type": "Education",
      "poi_address": "1501 Branch St, Platte City, MO 64079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-b6eb-7202-96dd-fe244a66a979.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b6eb-7202-96dd-fe244a66a979",
        "storage_key": "property/6767906449166542/019d7915-b6eb-7202-96dd-fe244a66a979.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://pchs.plattecountyschooldistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3597203914254826687&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "platte-county-high-school",
      "poi_latitude": "39.3589236",
      "poi_longitude": "-94.7712272",
      "poi_miles_from_property": "16.2 mi",
      "poi_walking_minutes": "5 hours 55 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 816-858-2822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-be00-761e-81e1-7f8a7f3bc920",
        "storage_key": "property/6767906449166542/019cfb4d-be00-761e-81e1-7f8a7f3bc920.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn5yqP01mwIcRv7zNtebV6zE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_e4a8fab8-035a-44a6-8ca2-4c6afca1a80a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "The Peanut",
      "poi_type": "Restaurants",
      "poi_address": "6409 N Cosby Ave, Kansas City, MO 64151, USA",
      "poi_short_description": "Wings, BLTs, and other comfort grub round out the menu at this casual sports bar with trivia nights.",
      "poi_long_description": "People say this bar and grill serves delicious chicken wings, BLTs, and nachos. They also highlight the large portions, reasonable prices, and fun atmosphere with TVs for watching sports.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-b4c1-771d-8a07-87d1b58ef434.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-b4c1-771d-8a07-87d1b58ef434",
        "storage_key": "property/6767906449166542/019d7915-b4c1-771d-8a07-87d1b58ef434.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.peanutmidwest.com/the-peanut-on-64th-kansas-city-mo/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7522284225338653675&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-peanut",
      "poi_latitude": "39.211713",
      "poi_longitude": "-94.6452507",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-859-5005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7916-0f54-725b-9326-840b7d9d9f3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7916-0f54-725b-9326-840b7d9d9f3c",
        "storage_key": "property/6767906449166542/019d7916-0f54-725b-9326-840b7d9d9f3c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR_LC4-H1wIcR67vV7qWFZGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_1a6c6362-e050-4c28-9fb3-22ddc073f47d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Chopstix Chinese Cuisine & Sushi",
      "poi_type": "Restaurants",
      "poi_address": "6003 NW Barry Rd, Kansas City, MO 64154, USA",
      "poi_short_description": "Casual Chinese restaurant serving a variety of dishes, including sushi, with vegetarian options.",
      "poi_long_description": "People say this Chinese restaurant serves delicious and flavorful dishes, including beef and broccoli, fried rice, lo mein, sweet and sour pork, and sushi. They highlight the generous portions, fair prices, and late-night specials. They also like the fast service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-c3d1-77f9-84a1-f728903d966d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-c3d1-77f9-84a1-f728903d966d",
        "storage_key": "property/6767906449166542/019d7915-c3d1-77f9-84a1-f728903d966d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://chopstixkcmo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17732453139663863525&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chopstix-chinese-cuisine-sushi",
      "poi_latitude": "39.2462925",
      "poi_longitude": "-94.6492123",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-701-6677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1zG4cNhfwIcR5b7sES5UFvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_8ba7dba7-5230-473e-97ae-08c97f3e1d33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Ixtapa Fine Mexican Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "7103 NW Barry Rd, Kansas City, MO 64153, USA",
      "poi_short_description": "Warm, casual nook in a strip mall offering classic & creative regional Mexican plates & happy hours.",
      "poi_long_description": "Diners say this Mexican restaurant serves up delicious pork chili verde burritos, tacos, and a great guacamole appetizer. They also highlight the friendly and efficient service, and the authentic, high-quality food that's a step above the usual Tex-Mex fare.\n\nSome reviews mention the portions can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-ca76-70fd-b953-3f7712721623.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-ca76-70fd-b953-3f7712721623",
        "storage_key": "property/6767906449166542/019d7915-ca76-70fd-b953-3f7712721623.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ixtapamexicancuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17760032784948398302&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ixtapa-fine-mexican-cuisine",
      "poi_latitude": "39.2463021",
      "poi_longitude": "-94.6621962",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-746-4848",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_1yf60BfwIcR3ggkorhPePY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_7adac501-6445-42b7-8b2b-624a1c1c0aa2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "500 NW Barry Rd, Kansas City, MO 64155, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Diners say this Italian restaurant serves up tasty breadsticks, soup, and flavorful pasta dishes. They also highlight the friendly and attentive staff, and the warm and welcoming atmosphere.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-cac7-7385-82dd-aaac9d35189a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-cac7-7385-82dd-aaac9d35189a",
        "storage_key": "property/6767906449166542/019d7915-cac7-7385-82dd-aaac9d35189a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.olivegarden.com/locations/mo/kansas-city/kansas-city-north-barry-road/1170?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:kansas-city-mo-1170_pl:locurl_rd:1120",
      "poi_directions_map_url": "https://maps.google.com/?cid=3382930713511415223&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "39.24691",
      "poi_longitude": "-94.586687",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-468-7540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9cgfgmtYwIcRt02bdo-V8i4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_8b9da758-7eaa-44a6-b9f6-9ce4ca57afba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Summit Grill",
      "poi_type": "Restaurants",
      "poi_address": "501 NE 70th St, Gladstone, MO 64118, USA",
      "poi_short_description": "Modern, industrial-style grill with traditional American fare & a long bar with craft beer on tap.",
      "poi_long_description": "People say this bar and grill serves delicious appetizers, brunch, calamari, carrot cake, chicken fried chicken, mac and cheese, pot roast, salmon, and steak. They highlight the fun, relaxing atmosphere and reasonable prices, especially during happy hour. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-cfbb-716b-81c9-22fe5178709d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-cfbb-716b-81c9-22fe5178709d",
        "storage_key": "property/6767906449166542/019d7915-cfbb-716b-81c9-22fe5178709d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.summitgrillkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18081813838441531057&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "summit-grill",
      "poi_latitude": "39.2208212",
      "poi_longitude": "-94.5747894",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-768-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD6EuiO_3wIcRscYMb-KB7_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9e3d8561-ed12-4d98-aa8a-84231d6b08aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Margarita's North",
      "poi_type": "Restaurants",
      "poi_address": "7013 N Oak Trafficway, Kansas City, MO 64118, USA",
      "poi_short_description": "Local Mexican chain serving classic dishes & margaritas in a relaxed atmosphere.",
      "poi_long_description": "People say this restaurant serves great Mexican food, including tacos, margaritas, and cheese dip. They also highlight the generous portions, reasonable prices, and quick service.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-d75a-75a8-8599-7714f7f23fd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d75a-75a8-8599-7714f7f23fd8",
        "storage_key": "property/6767906449166542/019d7915-d75a-75a8-8599-7714f7f23fd8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.margaritasamigos.com/margaritas-north",
      "poi_directions_map_url": "https://maps.google.com/?cid=9396503888003290727&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "margarita-s-north",
      "poi_latitude": "39.2220714",
      "poi_longitude": "-94.5756248",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-468-0337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmcHbj-X3wIcRZ1YDV4AWZ4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3d122946-4b07-4dc2-ad4b-83357a477aad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Smokehouse Barbecue - Kansas City, MO - Zona Rosa",
      "poi_type": "Restaurants",
      "poi_address": "8451 NW Prairie View Rd, Kansas City, MO 64153, USA",
      "poi_short_description": "One in a set of family-owned barbecue joints covering the basics with ribs, platters & side dishes.",
      "poi_long_description": "People say this barbecue restaurant serves delicious ribs, brisket, and burnt ends. They also highlight the warm and inviting atmosphere, and the friendly and attentive service.\n\nOther reviews mention the food can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-d71e-737f-ab68-df7a5355ac00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d71e-737f-ab68-df7a5355ac00",
        "storage_key": "property/6767906449166542/019d7915-d71e-737f-ab68-df7a5355ac00.webp",
        "width": 841,
        "height": 561
      },
      "poi_business_url": "https://www.smokehousebbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11003904934248052677&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "smokehouse-barbecue-kansas-city-mo-zona-rosa",
      "poi_latitude": "39.2483756",
      "poi_longitude": "-94.6608153",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-587-3337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ82_xVUdfwIcRxfcFjDy5tZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_b3dff793-d709-4398-8f4a-0993ca69b1fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Anejo Modern Mexican Cuisine Zona Rosa",
      "poi_type": "Restaurants",
      "poi_address": "8600 NW Prairie View Rd, Kansas City, MO 64153, USA",
      "poi_short_description": "Mexican food and cocktails, including an array of margaritas, served in a Zona Rosa locale.",
      "poi_long_description": "People say this Mexican restaurant serves delicious street tacos, chimichangas, and margaritas. They also highlight the vibrant atmosphere, reasonable prices, and attentive service.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-d8c1-702f-8787-cc1c21b9c692.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-d8c1-702f-8787-cc1c21b9c692",
        "storage_key": "property/6767906449166542/019d7915-d8c1-702f-8787-cc1c21b9c692.webp",
        "width": 1093,
        "height": 1077
      },
      "poi_business_url": "http://anejomoderncuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15686301826684277052&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "anejo-modern-mexican-cuisine-zona-rosa",
      "poi_latitude": "39.2504617",
      "poi_longitude": "-94.661948",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-326-7073",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZM-tc1fwIcRPNET22bwsNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_9022f1b2-eb37-4509-98aa-d29bbbca85c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Cooper’s Hawk Winery & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1900 NW Tiffany Spgs Rd, Kansas City, MO 64154, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this American restaurant offers a great selection of dishes, including filet medallions, grouper, and salmon, and a wide variety of wines. They highlight the delicious food, the attentive service, and the inviting atmosphere, perfect for a date night or gathering with friends. They also like the wine tasting experience and the knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-e0f6-76a9-be34-5ef0f456f9b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e0f6-76a9-be34-5ef0f456f9b0",
        "storage_key": "property/6767906449166542/019d7915-e0f6-76a9-be34-5ef0f456f9b0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://chwinery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2169028529140415080&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cooper-s-hawk-winery-restaurant",
      "poi_latitude": "39.2604101",
      "poi_longitude": "-94.6019736",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-398-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTWRZJR1ZwIcRaDoai_TvGR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_1aeaabda-bf0c-4b0d-8595-b816c93b9d5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Imo's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "8502 N Jefferson St, Kansas City, MO 64155, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-e152-77fd-bafe-94442aff143d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e152-77fd-bafe-94442aff143d",
        "storage_key": "property/6767906449166542/019d7915-e152-77fd-bafe-94442aff143d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.imospizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3421303785456589321&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "imo-s-pizza",
      "poi_latitude": "39.2478085",
      "poi_longitude": "-94.5887453",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-897-3777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsWF_ZwBZwIcRCdrWgKrpei8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_17ad1ed3-e11b-47d0-b197-1d82c16de836",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "KPOT Korean BBQ & Hot Pot",
      "poi_type": "Restaurants",
      "poi_address": "8502 N Jefferson St, Kansas City, MO 64155, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this Korean barbecue restaurant offers a wide variety of fresh meats, vegetables, and broths for both hot pot and grilling. They highlight the fun, interactive dining experience, and the delicious, customizable sauces available at the sauce bar. They also like the attentive and friendly service, and the quick delivery of food.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-e62f-7413-80a4-b6e89f3ac79f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-e62f-7413-80a4-b6e89f3ac79f",
        "storage_key": "property/6767906449166542/019d7915-e62f-7413-80a4-b6e89f3ac79f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thekpot.com/location/kansas-city-mo/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7701220610722916092&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kpot-korean-bbq-hot-pot",
      "poi_latitude": "39.2478414",
      "poi_longitude": "-94.5884138",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-883-8066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5Xa-rsJZwIcR_GYOt1c74Go",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_barbecue_restaurant"
    },
    {
      "id": "custom_68c3dc27-e5e5-4501-9d61-2d54b684c7ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Hy-Vee Deli",
      "poi_type": "Shopping & Retail",
      "poi_address": "8301 N St Clair Ave, Kansas City, MO 64151, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.hy-vee.com/aisles-online/category/deli?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing&utm_content=deli",
      "poi_directions_map_url": "https://maps.google.com/?cid=5912639063706039869&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hy-vee-deli",
      "poi_latitude": "39.2454922",
      "poi_longitude": "-94.6456854",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-505-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdf8-7038-ab76-4d70d9b89f5e",
        "storage_key": "property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJs7qYqppfwIcRPfZL5ebpDVI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "custom_1a5f1e91-64b3-4a96-99a8-ca36a2e53653",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Costco Gas Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "1600 NW 88th St, Kansas City, MO 64155, USA",
      "poi_short_description": "Gas station for Costco members only, with taps and fuel attendants, and competitive gas prices.",
      "poi_long_description": "People say this gas station offers unleaded, premium, and diesel fuel. They highlight the consistently low prices and the quick service, even during peak times. They also like the clean and well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-f0b8-7638-a852-0a61600b7ca4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f0b8-7638-a852-0a61600b7ca4",
        "storage_key": "property/6767906449166542/019d7915-f0b8-7638-a852-0a61600b7ca4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/n-kansas-city-kansas-city-mo-1268.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12110577539962905710&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "costco-gas-station",
      "poi_latitude": "39.2538857",
      "poi_longitude": "-94.59773020000002",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-857-7086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdf7-7787-87dd-5c844bdce91d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdf7-7787-87dd-5c844bdce91d",
        "storage_key": "property/6767906449166542/019cfb4d-bdf7-7787-87dd-5c844bdce91d.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZez9fRYwIcRbiRQphtqEag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_8d35e4d0-1760-4986-ad4d-98ed0e8fca82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Sam's Club Floral",
      "poi_type": "Shopping & Retail",
      "poi_address": "5110 N Oak Trafficway, Kansas City, MO 64118, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-f1fb-72bd-9f1b-4252f630cb2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f1fb-72bd-9f1b-4252f630cb2b",
        "storage_key": "property/6767906449166542/019d7915-f1fb-72bd-9f1b-4252f630cb2b.webp",
        "width": 400,
        "height": 400
      },
      "poi_business_url": "https://www.samsclub.com/club/8207-kansas-city-mo?FLO=aL",
      "poi_directions_map_url": "https://maps.google.com/?cid=16645041094139084514&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club-floral",
      "poi_latitude": "39.1866348",
      "poi_longitude": "-94.5797753",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-452-0005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdf8-7038-ab76-4d70d9b89f5e",
        "storage_key": "property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5cyOTXT3wIcR4n7wl68Q_-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "florist"
    },
    {
      "id": "custom_2a26acb4-a78b-41e8-906d-fc2512b93087",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Petco",
      "poi_type": "Shopping & Retail",
      "poi_address": "8600 N Madison Ave, Kansas City, MO 64155, USA",
      "poi_short_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_long_description": "People say this pet store offers a wide variety of pet supplies, self-service animal wash stations, grooming services, and even has cats available for adoption. They also highlight the friendly and helpful staff who go above and beyond to assist customers.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-f3bd-74f9-b229-cf7e4107456b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f3bd-74f9-b229-cf7e4107456b",
        "storage_key": "property/6767906449166542/019d7915-f3bd-74f9-b229-cf7e4107456b.webp",
        "width": 1280,
        "height": 1023
      },
      "poi_business_url": "https://stores.petco.com/mo/kansascity/pet-supplies-kansascity-mo-2620.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3810224740447526249&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "petco",
      "poi_latitude": "39.2512084",
      "poi_longitude": "-94.5949429",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-448-4639",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdf8-7038-ab76-4d70d9b89f5e",
        "storage_key": "property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaadPtfRZwIcRaZ3HyDaj4DQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_store"
    },
    {
      "id": "custom_48b8d528-82e7-489b-a13b-1b8dd5f49304",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "8601 N Boardwalk Ave, Kansas City, MO 64154, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a great selection of products, including BBQs, wood, cleaning supplies, housewares, dog toys, plants, and tools. They also highlight the friendly and helpful staff who are always willing to assist customers.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-f561-74df-aa8d-d129d624ec82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-f561-74df-aa8d-d129d624ec82",
        "storage_key": "property/6767906449166542/019d7915-f561-74df-aa8d-d129d624ec82.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/MO-Kansas-City/1078?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1078-_-na-_-0-_-0&y_source=1_MTE4NDE0My03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3339343781079351747&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lowe-s-home-improvement",
      "poi_latitude": "39.2505093",
      "poi_longitude": "-94.6522376",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-746-4211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdf8-7038-ab76-4d70d9b89f5e",
        "storage_key": "property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJ9aDWTZfwIcRwwEl7nm7Vy4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_061ade10-1549-4206-8a5a-79299fbba544",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Savers",
      "poi_type": "Shopping & Retail",
      "poi_address": "2251 NW Barry Rd, Kansas City, MO 64154, USA",
      "poi_short_description": "Thrift store chain offering secondhand clothing, footwear, furniture, books & household items.",
      "poi_long_description": "People say this thrift store offers a wide variety of items, including clothing, household goods, and jewelry, and can be fun to search for unique finds.\n\nOther reviews mention the prices can be high and the return policy can be restrictive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-fbac-7468-b9a1-0540c93c3a12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-fbac-7468-b9a1-0540c93c3a12",
        "storage_key": "property/6767906449166542/019d7915-fbac-7468-b9a1-0540c93c3a12.webp",
        "width": 496,
        "height": 279
      },
      "poi_business_url": "https://stores.savers.com/mo/kansascity/savers-thrift-store-1223.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11124379020977244849&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "savers",
      "poi_latitude": "39.2457845",
      "poi_longitude": "-94.6067516",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-436-0411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdf8-7038-ab76-4d70d9b89f5e",
        "storage_key": "property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJRwkR04tYwIcRsQootMe7YZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thrift_store"
    },
    {
      "id": "custom_94f194c6-8eee-48f7-a8f4-6fc041e16512",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "8551 N Boardwalk Ave, Kansas City, MO 64154, USA",
      "poi_short_description": "Retailer featuring electronics and clothing as well as groceries, home goods and furniture.",
      "poi_long_description": "People say this department store offers a wide variety of products, including groceries, electronics, and clothing, and has reasonable prices.\n\nOther reviews mention the service can be unhelpful and the store can be disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-a125-729e-b4ed-9c8dc12e52a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-a125-729e-b4ed-9c8dc12e52a2",
        "storage_key": "property/6767906449166542/019cfb4d-a125-729e-b4ed-9c8dc12e52a2.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2857-kansas-city-mo/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17711156065469962940&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "39.2503922",
      "poi_longitude": "-94.6545605",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-741-1099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdf8-7038-ab76-4d70d9b89f5e",
        "storage_key": "property/6767906449166542/019cfb4d-bdf8-7038-ab76-4d70d9b89f5e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmw5OgzdfwIcRvJrXk5qqyvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_737efedd-5d43-4041-8ccc-d3b821ccf828",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "B&B KC Northland 14",
      "poi_type": "Entertainment",
      "poi_address": "4900 NE 80th St, Kansas City, MO 64119, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "People say this movie theater offers comfortable reclining seats and a great movie experience. They also highlight the friendly staff and clean facilities.\n\nOther reviews mention the snacks can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7915-fffa-75f7-8d04-0829b67d1e9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7915-fffa-75f7-8d04-0829b67d1e9a",
        "storage_key": "property/6767906449166542/019d7915-fffa-75f7-8d04-0829b67d1e9a.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x0uvg-b-and-b-kc-northland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17679910262764140181&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "b-b-kc-northland-14",
      "poi_latitude": "39.239301",
      "poi_longitude": "-94.5225626",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-468-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdee-7315-ac73-30ad6291caf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdee-7315-ac73-30ad6291caf5",
        "storage_key": "property/6767906449166542/019cfb4d-bdee-7315-ac73-30ad6291caf5.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJodA5FNNXwIcRlfbWOLaoW_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_188d34b3-607b-4637-a42a-72b4fb1ae699",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "T-Shotz Golf and Entertainment Venue",
      "poi_type": "Entertainment",
      "poi_address": "660 NW Metro N Dr, Kansas City, MO 64155, USA",
      "poi_short_description": "Golf driving range with 3 levels of climate-controlled hitting bays, plus pickleball courts and a bar.",
      "poi_long_description": "People say this restaurant offers a fun golfing experience with a variety of games and activities, including pickleball and duckpin bowling. They also highlight the lively and welcoming atmosphere, and the friendly and helpful staff.\n\nOther reviews mention the food can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-aaca-73fb-8c90-526d67236a35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb4d-aaca-73fb-8c90-526d67236a35",
        "storage_key": "property/6767906449166542/019cfb4d-aaca-73fb-8c90-526d67236a35.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.tshotz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10761970676467943303&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "t-shotz-golf-and-entertainment-venue",
      "poi_latitude": "39.252194",
      "poi_longitude": "-94.587114",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-702-1320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfa-776d-abfa-82e1fb4513bd",
        "storage_key": "property/6767906449166542/019cfb4d-bdfa-776d-abfa-82e1fb4513bd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVfEdadBZwIcRh8cKlk8zWpU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a97b5d75-ad5f-472a-8918-c88bbb2df7da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "The Rush Funplex",
      "poi_type": "Entertainment",
      "poi_address": "309 NE Englewood Rd, Kansas City, MO 64118, USA",
      "poi_short_description": "Large, clean entertainment center with go-karts, mini golf, trampoline area, laser tag and an arcade.",
      "poi_long_description": "People say this amusement center offers a wide variety of fun activities, including go-karts, laser tag, mini golf, bowling, bumper cars, and a foam pit. They also highlight the reasonable prices, especially for larger groups, and the clean and well-maintained facilities.\n\nOther reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7916-02b7-7018-b893-6cb0824b6cc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-02b7-7018-b893-6cb0824b6cc2",
        "storage_key": "property/6767906449166542/019d7916-02b7-7018-b893-6cb0824b6cc2.webp",
        "width": 1060,
        "height": 596
      },
      "poi_business_url": "https://www.therushfunplex.com/kansas-city-mo/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14212064490203117647&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-rush-funplex",
      "poi_latitude": "39.1934918",
      "poi_longitude": "-94.5779712",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-829-9864",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-bdfd-74fa-b2b9-0a1271f5b873",
        "storage_key": "property/6767906449166542/019cfb4d-bdfd-74fa-b2b9-0a1271f5b873.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuQ5SevP3wIcRT_h_51plO8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_16618b7b-b409-4ad2-b416-c003b9c57557",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Argosy Casino & Hotel",
      "poi_type": "Entertainment",
      "poi_address": "777 NW Argosy Casino Pkwy, Riverside, MO 64150, USA",
      "poi_short_description": "Riverfront casino hotel with sleek quarters, a full-service spa & several dining options.",
      "poi_long_description": "Visitors say this casino hotel has clean rooms, friendly staff, and a great steakhouse. They also highlight the amazing showers, comfortable beds, and fun atmosphere.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7916-0391-7640-af6c-6a3e5d25b5d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-0391-7640-af6c-6a3e5d25b5d3",
        "storage_key": "property/6767906449166542/019d7916-0391-7640-af6c-6a3e5d25b5d3.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.argosykansascity.com/?utm_source=google&utm_medium=organic&utm_campaign=localseo",
      "poi_directions_map_url": "https://maps.google.com/?cid=1247987996450272660&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "argosy-casino-hotel",
      "poi_latitude": "39.16100309999999",
      "poi_longitude": "-94.6204681",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-746-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-be01-72e2-aca3-705034a217d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-be01-72e2-aca3-705034a217d0",
        "storage_key": "property/6767906449166542/019cfb4d-be01-72e2-aca3-705034a217d0.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJAQCaWL_2wIcRlLVefHi-URE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_9ff1e994-b28c-4853-8d39-efaaf60e0ff6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "poi_name": "Platte Purchase Park",
      "poi_type": "Entertainment",
      "poi_address": "N Platte Purchase Dr & NW 100 St, Kansas City, MO 64154, USA",
      "poi_short_description": "Athletic park with baseball fields and a playground, plus a walking trail.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d7916-0527-7044-9419-84e3c3b2ce2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7916-0527-7044-9419-84e3c3b2ce2d",
        "storage_key": "property/6767906449166542/019d7916-0527-7044-9419-84e3c3b2ce2d.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://kcparks.org/places/platte-purchase-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9456642059924448902&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "platte-purchase-park",
      "poi_latitude": "39.2778579",
      "poi_longitude": "-94.608322",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-be3a-70ca-b887-addf07ef7395.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-be3a-70ca-b887-addf07ef7395",
        "storage_key": "property/6767906449166542/019cfb4d-be3a-70ca-b887-addf07ef7395.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJybnH8wZZwIcRhqbQndm9PIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    }
  ],
  "office_hours": [
    {
      "id": "ec_7012976d9aeeeb9fa463becb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_f5be546e1fa8b04325fee37c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_3180d2971d73092a258fc88e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_4f96cbde66614ef5e946b443",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_290cc2ba10dcc29b7f82b50a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_3bee26de73d824934d31e902",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "14:30"
    },
    {
      "id": "ec_dc25ae1bac384920386ea590",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "16:30"
    }
  ],
  "reviews": [],
  "virtual_tours": [
    {
      "id": "custom_2bc64995-0443-453f-a12a-26b7f17df460",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d20b6-fc78-76f9-a8b8-b4542387894d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of a modern kitchen with island and living room in background.",
        "public_id": "019d20b6-fc78-76f9-a8b8-b4542387894d",
        "storage_key": "property/6767906449166542/019d20b6-fc78-76f9-a8b8-b4542387894d.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Adirondack Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=69096c0bcae08b6164a6f820"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a03f0-fec9-743f-83c8-20614a9149b6",
      "lead_source": "LANDING_PAGE",
      "name": "case-152-northland-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542"
    },
    {
      "lead_collector_id": "019cf79d-2c15-7176-8af7-bb06c885f554",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "152-northland",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "apartments-with-sundeck-kansas-city-mo",
      "search_query": "apartments with sundeck Kansas City MO",
      "category": "Amenity",
      "h1_title": "Apartments with Sundeck in Kansas City MO",
      "h2_subtitle": "Discover apartments with sundeck in Kansas City, MO. Explore top-notch amenities at 152 Northland, including a sundeck and modern living spaces.",
      "page_copy": "Experience the luxury of outdoor relaxation at 152 Northland, the prime location for apartments with sundeck in Kansas City, MO. Our sundeck provides the perfect setting to unwind after a busy day in the city, offering a serene atmosphere with beautiful views. Combined with a variety of one and two-bedroom floor plans, each apartment is designed to maximize comfort and style.\n\nAt 152 Northland, amenities extend beyond the sundeck. Enjoy access to our state-of-the-art fitness center and a welcoming clubhouse that fosters community connections. Our modern apartments boast unique flex spaces and spacious designs, ensuring you find the perfect layout to suit your lifestyle. Come and explore why 152 Northland is the ideal choice for those seeking top-tier apartment living in Kansas City, MO.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Sundeck in Kansas City MO",
      "seo_description": "Discover 152 Northland's apartments with sundeck in Kansas City, MO. Enjoy modern living with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "modern-fitness-center-apartments-platte-county",
      "search_query": "modern fitness center apartments Platte County",
      "category": "Amenity",
      "h1_title": "Modern Fitness Center Apartments Platte County",
      "h2_subtitle": "Explore modern fitness center apartments in Platte County. 152 Northland offers advanced amenities and prime living options for a healthy lifestyle.",
      "page_copy": "152 Northland presents an ideal choice for those seeking modern fitness center apartments in Platte County. Our state-of-the-art fitness center is just one of the premium amenities available, designed to cater to various workout regimens and enhance your active lifestyle. You’ll appreciate the blend of convenience and modernity right at your doorstep.\n\nLocated in the scenic Outer Northland-Platte County, 152 Northland offers a harmonious balance of contemporary living and comfort. Choose from spacious one and two-bedroom layouts, each featuring modern appliances and private balconies. Immerse yourself in a community that prioritizes your wellness and comfort, making it the perfect place to call home in Kansas City, MO.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Fitness Center Apartments Platte County",
      "seo_description": "Find modern fitness center apartments in Platte County at 152 Northland. Enjoy top-tier amenities enhancing your living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "poolside-apartments-outer-northland",
      "search_query": "poolside apartments Outer Northland",
      "category": "Amenity",
      "h1_title": "Poolside Apartments in Outer Northland",
      "h2_subtitle": "Discover poolside living at Outer Northland's premier apartments. At 152 Northland, we offer a perfect blend of relaxation and modern amenities.",
      "page_copy": "Live in style at 152 Northland, where poolside apartments in Outer Northland redefine luxury living. Imagine soaking up the sun by the pool in a community that values both leisure and modern conveniences. With spacious one and two-bedroom floor plans, our apartments are designed to accommodate a variety of lifestyles while providing easy access to Kansas City's vibrant offerings.\n\nLocated in the desirable Outer Northland-Platte County, 152 Northland ensures you enjoy top-of-the-line amenities. Enjoy not only poolside relaxation but also a fitness center and clubhouse to enhance your daily experience. Our unique layouts feature modern interiors with flex spaces, ensuring you have the living space you desire. Experience the lifestyle you deserve at 152 Northland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Poolside Apartments in Outer Northland",
      "seo_description": "Experience the poolside apartments at 152 Northland in Outer Northland. Enjoy relaxation and modern living close to amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "private-balcony-apartments-in-kansas-city",
      "search_query": "private balcony apartments in Kansas City",
      "category": "Amenity",
      "h1_title": "Private Balcony Apartments in Kansas City",
      "h2_subtitle": "Explore private balcony apartments in Kansas City. Enjoy modern comforts and serene views at 152 Northland, designed for your lifestyle.",
      "page_copy": "At 152 Northland, we offer exquisite private balcony apartments in Kansas City, where contemporary design meets peaceful outdoor spaces. Each unit provides a personal sanctuary with spacious layouts and modern interiors, perfect for those seeking a blend of relaxation and urban living. Your balcony becomes a retreat, offering a serene escape with picturesque views.\n\nSituated within the vibrant Outer Northland-Platte County, our community provides more than just private outdoor spaces. With access to a well-equipped fitness center, inviting clubhouse, and additional amenities, 152 Northland ensures a balanced lifestyle. Choose from one and two-bedroom apartments that emphasize both comfort and style, setting a new standard for city living in Kansas City, MO.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Private Balcony Apartments in Kansas City",
      "seo_description": "Find private balcony apartments at 152 Northland in Kansas City. Enjoy serene views and top amenities in a premier community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "luxury-clubhouse-living-kansas-city-mo",
      "search_query": "luxury clubhouse living Kansas City MO",
      "category": "Amenity",
      "h1_title": "Luxury Clubhouse Living in Kansas City, MO",
      "h2_subtitle": "Experience luxury clubhouse living in Kansas City, MO. At 152 Northland, enjoy exclusive amenities in an inviting community.",
      "page_copy": "152 Northland offers unparalleled luxury clubhouse living in Kansas City, MO. Our sophisticated clubhouse serves as the heart of the community, providing a welcoming space for social gatherings, relaxation, and entertainment. With its modern design and top-notch facilities, it complements our array of amenities like a state-of-the-art fitness center and a sun-drenched sundeck.\n\nSituated in the tranquil Outer Northland-Platte County, our community ensures you indulge in both comfort and style. Choose from uniquely designed one and two-bedroom apartments that feature spacious interiors, private balconies, and modern conveniences. At 152 Northland, luxury clubhouse living allows you to enjoy both a vibrant social life and a private retreat in Kansas City's preferred residential area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Clubhouse Living in Kansas City, MO",
      "seo_description": "Discover luxury clubhouse living at 152 Northland, Kansas City, MO. Enjoy exclusive amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-kansas-city-mo",
      "search_query": "one bedroom apartments kansas city mo",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Kansas City, MO",
      "h2_subtitle": "Explore one bedroom apartments in Kansas City, MO at 152 Northland. Enjoy spacious layouts and modern amenities in an ideal location.",
      "page_copy": "Discover the perfect one bedroom apartments in Kansas City, MO at 152 Northland. Our thoughtfully designed units offer spacious layouts complete with contemporary finishes, ensuring a comfortable and stylish living experience. Each apartment features modern appliances and private balconies, providing the ideal retreat from the city's hustle and bustle.\n\nLocated in the desirable Outer Northland-Platte County, our community offers more than just a place to live. Enjoy our exclusive amenities including a fitness center, sundeck, and luxury clubhouse. Whether you're relaxing at home or socializing with neighbors, 152 Northland provides the perfect blend of comfort and convenience in Kansas City, MO.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Kansas City, MO",
      "seo_description": "Find spacious one bedroom apartments at 152 Northland in Kansas City, MO. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "two-bedroom-floor-plans-platte-county-mo",
      "search_query": "two bedroom floor plans platte county mo",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floor Plans in Platte County, MO",
      "h2_subtitle": "Explore two bedroom floor plans in Platte County, MO at 152 Northland. Experience modern living with spacious layouts and premium amenities.",
      "page_copy": "At 152 Northland, discover exceptional two bedroom floor plans in Platte County, MO. Our unique layouts offer spacious interiors designed for modern living, complete with private balconies to enjoy serene views. The open-concept designs incorporate premium fixtures and flexible space, ensuring a home that suits your lifestyle.\n\nSituated in the coveted Outer Northland-Platte County, our community provides access to stellar amenities such as a well-equipped fitness center, a relaxing sundeck, and a stylish clubhouse. 152 Northland combines comfort and convenience, making it the perfect place to call home in Kansas City. Whether you're hosting friends or enjoying a quiet night in, our two bedroom apartments offer an unparalleled living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floor Plans in Platte County, MO",
      "seo_description": "Explore spacious two bedroom floor plans at 152 Northland in Platte County, MO. Enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "apartments-near-hopewell-elementary-school-kc",
      "search_query": "apartments near hopewell elementary school kansas city",
      "category": "School",
      "h1_title": "Apartments Near Hopewell Elementary, Kansas City",
      "h2_subtitle": "Discover apartments near Hopewell Elementary School in Kansas City at 152 Northland. Enjoy family-friendly living with modern conveniences.",
      "page_copy": "Located conveniently near Hopewell Elementary School, 152 Northland provides ideal family-friendly apartments in Kansas City. Our property offers unique one and two-bedroom layouts, designed to accommodate your family with spacious living areas and contemporary amenities. Each apartment is outfitted with modern appliances, vaulted ceilings, and private balconies, perfect for both relaxation and entertainment.\n\nFamily life thrives at 152 Northland, with its range of community amenities including a fitness center, a welcoming clubhouse, and curbside trash pickup. Nestled in the Outer Northland-Platte County, residents enjoy the tranquility of suburban living while maintaining easy access to Kansas City’s vibrant attractions. Come see why our community is the perfect home for families seeking quality education and exceptional living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hopewell Elementary, KC",
      "seo_description": "Find family-friendly apartments near Hopewell Elementary in Kansas City at 152 Northland. Enjoy modern amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "apartments-by-line-creek-elementary-school-mo",
      "search_query": "apartments by line creek elementary school mo",
      "category": "School",
      "h1_title": "Apartments by Line Creek Elementary School, MO",
      "h2_subtitle": "Explore living near Line Creek Elementary School, MO at 152 Northland. Enjoy modern apartments with easy access to educational facilities.",
      "page_copy": "152 Northland offers an excellent choice for those seeking apartments by Line Creek Elementary School in MO. Our community features unique one and two-bedroom layouts with spacious, well-designed living areas and modern amenities, perfect for families prioritizing education. Each apartment boasts contemporary appliances and private outdoor spaces, ensuring both comfort and style.\n\nSituated in the Outer Northland-Platte County, 152 Northland provides a serene environment conducive to both family life and academic excellence. Residents have access to a range of top-tier amenities, including a fitness center and an inviting clubhouse. With close proximity to Line Creek Elementary School, our location offers convenience for families focused on quality education and vibrant community living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Line Creek Elementary, MO",
      "seo_description": "Discover modern apartments near Line Creek Elementary School, MO at 152 Northland. Enjoy a vibrant community with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "apartments-close-tiffany-ridge-elementary-outer-northland",
      "search_query": "apartments close to tiffany ridge elementary school outer northland",
      "category": "School",
      "h1_title": "Apartments Close to Tiffany Ridge Elementary",
      "h2_subtitle": "Find homes close to Tiffany Ridge Elementary School in the Outer Northland. Experience convenience and comfort at 152 Northland.",
      "page_copy": "152 Northland, nestled in the Outer Northland, offers a perfect location for families looking for apartments close to Tiffany Ridge Elementary School. Our community provides distinct one and two-bedroom floor plans designed with both style and functionality in mind. Enjoy modern comforts with features like spacious layouts, private balconies, and up-to-date appliances.\n\nLiving at 152 Northland means having access to exceptional amenities, including a contemporary fitness center, a tranquil sundeck, and a welcoming clubhouse perfect for gathering with friends and family. The ideal setting near Tiffany Ridge Elementary affords quick access to quality education while also enjoying the peace and quiet of the Outer Northland-Platte County community. Explore the benefits of living at 152 Northland today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tiffany Ridge Elementary",
      "seo_description": "Discover convenient living near Tiffany Ridge Elementary School in Outer Northland at 152 Northland. Modern amenities and spacious layouts await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "plaza-middle-school-kansas-city-apartments",
      "search_query": "plaza middle school kansas city apartments",
      "category": "School",
      "h1_title": "Kansas City Apartments by Plaza Middle School",
      "h2_subtitle": "Explore Kansas City apartments near Plaza Middle School at 152 Northland. Enjoy modern living with exceptional amenities nearby.",
      "page_copy": "Located near Plaza Middle School, Kansas City, 152 Northland offers a prime living choice for families who value education. Our community features unique one and two-bedroom apartments, boasting modern amenities that cater to today's lifestyle. With spacious interiors, vaulted ceilings, and private balconies, these homes provide a comfortable retreat for all.\n\nLiving at 152 Northland means being part of a vibrant community with easy access to educational facilities and city attractions. Enjoy unparalleled amenities like a fitness center, a sundeck, and a clubhouse. Situated in the Outer Northland-Platte County, our apartments offer both convenience and tranquility, making it an ideal home base for families with students attending Plaza Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Plaza Middle School, KC",
      "seo_description": "Discover Kansas City apartments near Plaza Middle School at 152 Northland. Modern living with family-friendly amenities awaits!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "lakeview-middle-school-area-apartments-64154",
      "search_query": "lakeview middle school area apartments 64154",
      "category": "School",
      "h1_title": "Apartments in Lakeview Middle School Area 64154",
      "h2_subtitle": "Discover a perfect home in the Lakeview Middle School area, 64154. 152 Northland offers ultimate comfort and convenience in Kansas City.",
      "page_copy": "152 Northland is an ideal choice for families looking for apartments in the Lakeview Middle School area, 64154. Our community offers thoughtfully designed one and two-bedroom floor plans, featuring spacious living spaces, modern kitchens, and private balconies. Enjoy the best in contemporary living with top-notch amenities that suit your lifestyle.\n\nSituated in the peaceful Outer Northland-Platte County, 152 Northland caters to those seeking both comfort and accessibility. With a state-of-the-art fitness center, inviting sundeck, and a resident-friendly clubhouse, you'll enjoy a balanced lifestyle at home. Proximity to Lakeview Middle School ensures educational convenience while you immerse yourself in the dynamic Kansas City area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lakeview Middle School, 64154",
      "seo_description": "Find your home at 152 Northland, offering comfort near Lakeview Middle School, 64154. Modern amenities and spacious living designed for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "apartments-near-park-hill-high-school-platte-county",
      "search_query": "apartments near park hill high school platte county",
      "category": "School",
      "h1_title": "Platte County Apartments Near Park Hill High",
      "h2_subtitle": "Discover comfortable living in Platte County near Park Hill High School. Explore the modern features of 152 Northland today.",
      "page_copy": "For families seeking apartments near Park Hill High School in Platte County, 152 Northland offers an unbeatable combination of location and lifestyle. With stylish one and two-bedroom floor plans, residents enjoy spacious interiors equipped with the latest appliances, along with desirable extras like private balconies and vaulted ceilings.\n\nResidents can indulge in community amenities such as a well-equipped fitness center, a calming sundeck, and a welcoming clubhouse for social events. Nestled in the serene surroundings of Outer Northland-Platte County, 152 Northland ensures a peaceful living environment along with easy access to top-rated schools like Park Hill High, making it an excellent choice for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Park Hill High, Platte County",
      "seo_description": "Find comfort and convenience near Park Hill High School at 152 Northland, Platte County. Modern lifestyle amenities and spacious designs await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "apartments-by-metropolitan-community-college-maple-woods-64154",
      "search_query": "apartments by metropolitan community college maple woods 64154",
      "category": "School",
      "h1_title": "Apartments Near MCC Maple Woods, 64154",
      "h2_subtitle": "Explore apartments near Metropolitan Community College Maple Woods, 64154. Discover 152 Northland's modern amenities and convenient location.",
      "page_copy": "152 Northland provides an ideal living option for those seeking apartments by Metropolitan Community College Maple Woods in the 64154 area. With unique one and two-bedroom floor plans, our apartments feature spacious interiors, modern kitchens, and private balconies, offering comfort and style for all residents.\n\nApart from the strategic location near MCC Maple Woods, residents at 152 Northland enjoy a host of exclusive amenities, including a fully-equipped fitness center, a relaxing sundeck, and a vibrant clubhouse. Situated in Outer Northland-Platte County, living at 152 Northland means combining convenient access to educational facilities with serene residential living, making it an excellent choice for students and professionals alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near MCC Maple Woods, 64154",
      "seo_description": "Find your home at 152 Northland, near MCC Maple Woods, 64154. Enjoy modern living and convenient access to educational facilities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "park-university-apartments-kansas-city-mo",
      "search_query": "park university apartments in kansas city mo",
      "category": "School",
      "h1_title": "Kansas City MO Apartments Near Park University",
      "h2_subtitle": "Explore 152 Northland, perfectly located near Park University. Experience modern living in Kansas City, MO with unparalleled amenities.",
      "page_copy": "152 Northland offers an exceptional living experience for those seeking Park University apartments in Kansas City, MO. Choose from our distinct one and two-bedroom floor plans, each designed with spacious layouts, modern kitchens, and private balconies perfect for relaxing after a day of classes or work.\n\nSituated in the vibrant Outer Northland-Platte County, 152 Northland provides convenient access to Park University. Residents enjoy a range of top-tier amenities such as a state-of-the-art fitness center, inviting sundeck, and engaging clubhouse. This ideal location ensures you’re close to both your educational pursuits and the lifestyle amenities that make life comfortable and convenient in Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Park University, Kansas City MO",
      "seo_description": "Discover modern apartments at 152 Northland, near Park University, Kansas City MO. Enjoy spacious living with easy access to campus amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "apartments-near-saint-lukes-north-hospital-kansas-city",
      "search_query": "apartments near saint luke's north hospital kansas city",
      "category": "Hospital",
      "h1_title": "Apartments by Saint Luke's North, Kansas City",
      "h2_subtitle": "Discover modern living near Saint Luke's North Hospital in Kansas City. 152 Northland offers spacious floor plans and top-notch amenities.",
      "page_copy": "If you're searching for apartments near Saint Luke's North Hospital in Kansas City, look no further than 152 Northland. Our community offers unique one and two-bedroom floor plans with spacious interiors, contemporary kitchens, and private balconies, providing both comfort and convenience.\n\nLocated in the serene Outer Northland-Platte County area, 152 Northland boasts proximity to Saint Luke's North Hospital. Residents enjoy exclusive amenities such as a comprehensive fitness center, relaxing sundeck, and engaging clubhouse, making it an ideal living choice. Enjoy the peace of mind that comes from quick access to esteemed healthcare facilities while relishing modern living in a beautiful community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saint Luke's North Hospital, KC",
      "seo_description": "Live near Saint Luke's North Hospital at 152 Northland, KC. Enjoy spacious, modern apartments and premium amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "apartments-near-frank-vaydik-park-kansas-city",
      "search_query": "apartments near Frank Vaydik Park Kansas City",
      "category": "Park",
      "h1_title": "Apartments by Frank Vaydik Park, Kansas City",
      "h2_subtitle": "Explore living near Frank Vaydik Park in Kansas City. Discover the modern comforts offered at 152 Northland, perfectly located for outdoor enthusiasts.",
      "page_copy": "152 Northland is the perfect choice for those searching for apartments near Frank Vaydik Park, Kansas City. Choose from our spacious one and two-bedroom floor plans, designed with modern kitchens, private balconies, and flexible living spaces ideal for any lifestyle.\n\nNestled in the picturesque Outer Northland-Platte County, 152 Northland not only provides easy access to Frank Vaydik Park but also features exceptional amenities such as a state-of-the-art fitness center, a sun-drenched sundeck, and a community clubhouse. Whether you’re keen on enjoying the great outdoors or relaxing in a well-appointed home, our community offers the ideal balance between nature and modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Frank Vaydik Park, KC",
      "seo_description": "Discover living by Frank Vaydik Park at 152 Northland in KC. Enjoy modern apartments with premium amenities in a prime location for nature lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "platte-purchase-park-nearby-apartments-outer-northland",
      "search_query": "Platte Purchase Park nearby apartments Outer Northland",
      "category": "Park",
      "h1_title": "Apartments Near Platte Purchase Park, Outer Northland",
      "h2_subtitle": "Live near Platte Purchase Park in Outer Northland. Discover 152 Northland's modern apartments that blend comfort with recreational access.",
      "page_copy": "Discover the ideal location at 152 Northland for those seeking Platte Purchase Park nearby apartments in Outer Northland. Our community offers spacious one and two-bedroom floor plans, complete with modern kitchens, vaulted ceilings, and private balconies, creating a perfect living environment.\n\nSituated in the serene Outer Northland-Platte County, 152 Northland provides quick access to Platte Purchase Park, making it an excellent choice for those who love outdoor activities. Enjoy amenities such as a fully equipped fitness center, inviting sundeck, and a social clubhouse. Embrace the blend of active living and comfortable accommodation that defines life at 152 Northland in Kansas City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Platte Purchase Park Apartments, Outer Northland",
      "seo_description": "Live near Platte Purchase Park at 152 Northland, Outer Northland. Enjoy spacious, modern apartments with easy access to park amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "platte-landing-park-close-to-kansas-city-apartments",
      "search_query": "Platte Landing Park close to Kansas City apartments",
      "category": "Park",
      "h1_title": "Kansas City Apartments Near Platte Landing Park",
      "h2_subtitle": "Discover apartments close to Platte Landing Park in Kansas City. Enjoy the blend of modern living with nearby recreational spaces at 152 Northland.",
      "page_copy": "152 Northland offers Kansas City apartments near Platte Landing Park, an ideal setting for those who cherish being near nature. Our one and two-bedroom floor plans feature modern designs, private balconies, and flexible living spaces that cater to diverse lifestyles.\n\nLocated in the Outer Northland-Platte County, 152 Northland provides the peace of suburban life while keeping you close to Platte Landing Park. Alongside proximity to scenic outdoor attractions, enjoy on-site amenities such as a full fitness center, relaxing sundeck, and a vibrant clubhouse, making life at 152 Northland both comfortable and engaging.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "KC Apartments Near Platte Landing Park",
      "seo_description": "Find the perfect KC apartment close to Platte Landing Park at 152 Northland. Enjoy modern living with easy access to recreational activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "apartments-close-to-english-landing-park-64154",
      "search_query": "apartments close to English Landing Park 64154",
      "category": "Park",
      "h1_title": "Apartments Near English Landing Park, 64154",
      "h2_subtitle": "Discover apartments close to English Landing Park in the 64154 area. Enjoy modern living and nearby outdoor adventures at 152 Northland.",
      "page_copy": "Welcome to 152 Northland, your destination for apartments close to English Landing Park in the 64154 area. Our community offers thoughtfully designed one and two-bedroom apartments that feature contemporary amenities such as spacious kitchens, private balconies, and unique floor plans with flex space.\n\nLocated in Kansas City's Outer Northland-Platte County, 152 Northland combines convenience with comfort, providing easy access to the scenic trails and activities at English Landing Park. Our residents enjoy a variety of on-site features, including a fitness center, sundeck, and clubhouse, making it a perfect place for those who love a blend of outdoor adventure and modern comforts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near English Landing Park, 64154",
      "seo_description": "Discover modern living near English Landing Park at 152 Northland in the 64154 area. Enjoy unique apartments with easy access to nature and local amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "parkville-nature-sanctuary-near-kansas-city-mo-apartments",
      "search_query": "Parkville Nature Sanctuary near Kansas City MO apartments",
      "category": "Park",
      "h1_title": "KC MO Apartments Near Parkville Nature Sanctuary",
      "h2_subtitle": "Live near Parkville Nature Sanctuary with Kansas City, MO apartments. Discover serene living at 152 Northland, just a short distance away.",
      "page_copy": "Experience elevated living at 152 Northland, where your Kansas City, MO apartment meets the tranquility of Parkville Nature Sanctuary. Our unique community offers one and two-bedroom floor plans equipped with modern features like air conditioning, private balconies, and expansive kitchens.\n\nLocated conveniently close to the scenic Parkville Nature Sanctuary, 152 Northland offers the best of both worlds—serene nature trails and the comfort of modern living. Residents enjoy on-site amenities including a fitness center, sundeck, and a welcoming clubhouse, making it an ideal choice for those who appreciate both nature and luxury living in Kansas City, MO.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "KC MO Apartments by Parkville Nature Sanctuary",
      "seo_description": "Find serene living near Parkville Nature Sanctuary at 152 Northland. Enjoy modern Kansas City, MO apartments with nature access and top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "apartments-by-mark-l-mchenry-park-platte-county",
      "search_query": "apartments by Mark L. McHenry Park Platte County",
      "category": "Park",
      "h1_title": "Apartments Near Mark L. McHenry Park",
      "h2_subtitle": "Explore apartments by Mark L. McHenry Park in Platte County. Discover the perfect blend of nature and modern comfort at 152 Northland.",
      "page_copy": "Situated in the picturesque Outer Northland-Platte County, 152 Northland is ideal for those seeking apartments by Mark L. McHenry Park. Our stylish one and two-bedroom units boast contemporary features such as vaulted ceilings, curated floor plans with flex space, and air-conditioned living areas.\n\nEnjoy the convenience of living close to Mark L. McHenry Park while benefiting from our community's excellent amenities. At 152 Northland, you can relax on the sundeck, stay active at our fitness center, or unwind in the clubhouse, all while being steps away from the natural beauty of Platte County's finest park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Mark L. McHenry Park",
      "seo_description": "Discover modern living near Mark L. McHenry Park at 152 Northland. Enjoy stylish apartments with convenient access to Platte County's natural attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449166542",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Convenience meets comfort at apartments near Kansas City International Airport. Discover living at 152 Northland, just a quick drive away.",
      "page_copy": "At 152 Northland, enjoy the perfect blend of convenience and style in apartments near Kansas City International Airport. Located in a prime spot in Kansas City, MO, our community offers unique one and two-bedroom floor plans featuring spacious living areas, modern kitchens, and private balconies.\n\nOnly a short drive from the airport, 152 Northland provides exceptional ease for frequent travelers. Alongside the convenient location, our residents benefit from an array of amenities such as a fitness center, sundeck, and a vibrant clubhouse, making it an ideal choice for those who want modern comfort within easy reach of the airport's facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
      "featured_image_media": {
        "alt_text": "Living room with a leather sofa, armchair, coffee table, and a desk with a chair.",
        "public_id": "019cfb4d-775b-738d-ba95-0744848b90ad",
        "storage_key": "property/6767906449166542/019cfb4d-775b-738d-ba95-0744848b90ad.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "Find convenience at 152 Northland, near Kansas City International Airport. Enjoy modern apartments with easy airport access and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5138"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-7FGJDQQP2K"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18128850102"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/152-northland/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T5G2J3Z9"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d1bd6-8eb1-77eb-be75-3a9f3fe3c998.webp"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "888-886-9401"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImdPcnFnZUlXbHJCUWs4UjBVUm9QSmc9PSIsInZhbHVlIjoiOFU1UklGbUtiQldSWkVvK1JrQnJ1Zz09IiwibWFjIjoiNGVkMTQ4MWQyYjJiYWZjMzViYmY2ZTJkOTYzNTI3YjhjYTc3OWVmMDQ1ZWI5ZTA0YTRiNGI1N2IyOTkzZjg2MyJ9"
    }
  ],
  "custom_qb_id": "5138",
  "custom_ga4_id": "G-7FGJDQQP2K",
  "custom_repli_id": "18128850102",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/152-northland/register/",
  "custom_google_gtm_id": "GTM-T5G2J3Z9",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166542/019d1bd6-8eb1-77eb-be75-3a9f3fe3c998.webp",
  "custom_ppc_tracking_phone_number": "888-886-9401",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImdPcnFnZUlXbHJCUWs4UjBVUm9QSmc9PSIsInZhbHVlIjoiOFU1UklGbUtiQldSWkVvK1JrQnJ1Zz09IiwibWFjIjoiNGVkMTQ4MWQyYjJiYWZjMzViYmY2ZTJkOTYzNTI3YjhjYTc3OWVmMDQ1ZWI5ZTA0YTRiNGI1N2IyOTkzZjg2MyJ9"
};

export const generatedAt = '2026-08-27T21:00:29.996Z';
